import { DsAutocomplete as e, DsAvatar as t, DsBadge as n, DsCard as r, DsCell as i, DsColumn as a, DsCompactTrigger as o, DsDrawer as s, DsHeading as c, DsIconButton as l, DsLink as u, DsMenu as d, DsMenuItem as f, DsMenuSeparator as p, DsMenuTrigger as m, DsMenuTriggerButton as ee, DsPlainButton as h, DsPrevNextButtons as te, DsProgressBar as ne, DsRangeCalendarPopover as re, DsRow as ie, DsSelect as ae, DsSelectCompact as oe, DsSelectItem as se, DsTable as ce, DsTableBody as le, DsTableHeader as ue, DsToggleButton as de, DsToggleButtonGroup as fe, DsTooltip as pe, FIELD_DEFAULT_HEIGHT as me, FIELD_FOCUS_OUTLINE_CLASSES as he, dsToast as ge, useDsTooltipTrigger as _e } from "@frontends/ds";
import { useTranslation as g } from "react-i18next";
import { createContext as ve, useCallback as ye, useContext as be, useEffect as xe, useId as Se, useMemo as Ce, useRef as we, useState as _ } from "react";
import { keepPreviousData as Te, matchQuery as Ee, useMutation as De, useQuery as v } from "@tanstack/react-query";
import { transformToApiError as Oe } from "@frontends/util-api-errors";
import { CalendarDate as ke, Time as Ae, endOfMonth as je, fromDate as Me, getDayOfWeek as Ne, getLocalTimeZone as Pe, getWeeksInMonth as Fe, isSameMonth as Ie, parseAbsolute as Le, parseDate as Re, startOfWeek as ze, toCalendarDate as Be, toCalendarDateTime as y, toTimeZone as Ve, toZoned as He, today as Ue } from "@internationalized/date";
import { DecimalHelper as We, RoundingMode as Ge } from "@frontends/util-decimal";
import { Fragment as Ke, jsx as b, jsxs as x } from "react/jsx-runtime";
import { Navigate as qe, Outlet as Je, matchPath as Ye, useHref as Xe, useLocation as Ze, useNavigate as Qe, useParams as $e, useResolvedPath as et, useRoutes as tt, useSearchParams as nt } from "react-router";
import { cn as S } from "@frontends/util-cn";
import { I18nProvider as rt, RouterProvider as it } from "react-aria-components";
import { DsIcon as at } from "@frontends/ds-icons";
import { TradingDirection as ot, UiKitDeltaIndicator as st, UiKitEmptyState as ct, UiKitTruncatedText as C } from "@frontends/ui-kit";
import { createCurrencyFormatter as lt, formatCurrency as ut, formatNumber as dt } from "@frontends/util-utils";
import { SymbolIcon as ft, getSymbolLogoUrls as pt } from "@frontends/util-symbol-icons";
import { customFilter as mt, useDataTable as ht } from "@frontends/data-table";
//#region src/lib/period/timeZone.ts
var gt = "UTC", _t = /(?:Z|[+-]\d{2}:\d{2})$/i;
function w() {
	return Pe();
}
function T() {
	return Ue(w());
}
function vt() {
	return Ue("UTC");
}
function yt(e) {
	return Be(Le(_t.test(e) ? e : `${e}Z`, w()));
}
function bt(e, t) {
	return `${y(Ve(He(e, t), gt)).toString()}Z`;
}
function E(e) {
	return We.from(e);
}
function xt(e) {
	return e === null ? null : E(e);
}
function St(e) {
	return Re(e);
}
function D(e) {
	let t = e.trim();
	return t === "" ? null : t;
}
function Ct(e) {
	let t = D(e);
	return t === null ? null : St(t);
}
function wt(e) {
	return yt(e);
}
function Tt(e) {
	let t = new Date(e);
	if (Number.isNaN(t.getTime())) throw Error(`Invalid instant: ${e}`);
	return t;
}
function Et(e) {
	return e === null ? null : {
		value: E(e.value),
		unit: e.unit,
		trend: e.trend
	};
}
function Dt(e, t) {
	return {
		total: e.total,
		data: e.data.map((e, n) => t(e, n))
	};
}
function Ot(e) {
	return e?.trim() || "****";
}
//#endregion
//#region src/lib/api/mappers/calendar.ts
function kt(e) {
	return e.data.map((e) => ({
		date: St(e.date),
		value: E(e.value)
	}));
}
function At(e) {
	return {
		totalCommissionAmount: E(e.total_commission_amount),
		bestDayDate: Ct(e.best_day_date),
		bestDayAmount: E(e.best_day_amount),
		topPair: D(e.top_pair),
		topClientName: D(e.top_client_name)
	};
}
//#endregion
//#region src/lib/model/shared.ts
var jt = ["asc", "desc"], Mt = "search", Nt = "level", Pt = "period";
function Ft(e) {
	return e === "" ? null : e;
}
function It(e, t) {
	return e ?? t;
}
//#endregion
//#region src/lib/model/clients.ts
var Lt = [
	"active",
	"lowActivity",
	"inactive"
], Rt = [
	"registeredAt",
	"volumeLots",
	"rewards",
	"balance",
	"subClients"
];
function zt(e, t) {
	return t !== null && e.parentIbExternalId === t;
}
function Bt(e) {
	return It(e.parentIbName, e.parentIbEmail);
}
function Vt(e) {
	return {
		isZeroCommissionHidden: e.hideZero,
		search: Ft(e.search),
		status: Lt.find((t) => t === e.status) ?? null
	};
}
//#endregion
//#region src/lib/api/dto/clients.ts
var Ht = {
	active: "active",
	lowActivity: "dormantRisk",
	inactive: "inactive"
};
//#endregion
//#region src/lib/api/mappers/clients.ts
function Ut(e) {
	return Lt.find((t) => Ht[t] === e || t === e) ?? "inactive";
}
function Wt(e, t) {
	return {
		externalId: e.external_id,
		rowKey: `${e.external_id}-${t}`,
		name: D(e.name ?? ""),
		email: e.email,
		volumeLots: E(e.volume_lots),
		rewards: E(e.rewards),
		status: Ut(e.status),
		balance: E(e.balance),
		parentIbName: D(e.parent_ib_name),
		parentIbEmail: e.parent_ib_email,
		parentIbExternalId: e.parent_ib_external_id,
		subClients: e.sub_clients,
		registeredAt: wt(e.registered_at)
	};
}
//#endregion
//#region src/lib/api/mappers/dashboard.ts
function Gt(e) {
	return {
		amount: E(e.amount),
		date: Ct(e.date)
	};
}
function Kt(e) {
	return {
		active: e.active,
		networkTotal: e.network_total,
		lowActivity: e.low_activity,
		delta: Et(e.delta)
	};
}
function qt(e) {
	return {
		in: E(e.in),
		out: E(e.out),
		net: E(e.net),
		delta: Et(e.delta)
	};
}
function Jt(e) {
	let t = D(e ?? "");
	return t === null ? null : wt(t);
}
function Yt(e) {
	return e.data.map((e, t) => ({
		rowKey: `${e.name}-${t}`,
		name: D(e.name),
		email: e.email,
		rewards: E(e.rewards),
		balance: E(e.balance),
		netDeposits: E(e.net_deposits),
		lastTradeAt: Jt(e.last_trade_at),
		status: Ut(e.status)
	}));
}
function Xt(e) {
	return e.data.map((e, t) => ({
		rowKey: `${e.name}-${t}`,
		name: D(e.name),
		email: e.email,
		rewards: E(e.rewards.current)
	}));
}
//#endregion
//#region src/lib/api/mappers/impersonate.ts
function Zt(e) {
	return {
		impersonateList: e.impersonate_list ?? [],
		isAllowed: e.is_allowed
	};
}
//#endregion
//#region src/lib/api/mappers/programs.ts
function Qt(e) {
	return e.data.map((e) => ({
		clientId: e.client_id,
		name: Ot(e.name)
	}));
}
var $t = "indirect";
function en(e) {
	return e.filter((e) => e !== 1);
}
function tn(e, t) {
	if (e === "indirect") return en(t);
	let n = Number(e);
	return Number.isInteger(n) && n >= 1 ? [n] : null;
}
function nn(e) {
	if (e === "direct") return "1";
	if (e === "indirect") return $t;
}
//#endregion
//#region src/lib/model/rebates.ts
var rn = [
	"tradedAt",
	"volume",
	"rewards"
], an = ["buy", "sell"], on = ["client", "pair"];
function sn(e, t) {
	return {
		levels: tn(e.level, t),
		search: Ft(e.search)
	};
}
//#endregion
//#region src/lib/api/mappers/rebates.ts
function cn(e) {
	return an.find((t) => t === e) ?? null;
}
function ln(e, t) {
	return {
		rowKey: `${e.account}-${e.traded_at}-${t}`,
		name: D(e.name),
		email: e.email,
		level: e.level,
		account: e.account,
		side: cn(e.side),
		symbol: e.symbol,
		volume: E(e.volume),
		lots: E(e.lots),
		rewards: E(e.rewards),
		tradedAt: Tt(e.traded_at)
	};
}
function un(e) {
	return {
		totalVolume: E(e.total_volume),
		totalSymbols: e.total_symbols
	};
}
function dn(e) {
	return {
		totalRebates: E(e.total_rebates),
		rebatesPerLot: E(e.rebates_per_lot)
	};
}
function fn(e) {
	return {
		totalLots: E(e.total_lots),
		volumePercent: E(e.volume_percent)
	};
}
function pn(e) {
	return e.total_lots !== 0;
}
function mn(e) {
	return pn(e) ? {
		symbol: e.symbol,
		...fn(e)
	} : null;
}
function hn(e) {
	return pn(e) ? {
		name: D(e.name),
		...fn(e)
	} : null;
}
function gn(e) {
	return e.data;
}
function _n(e) {
	return {
		name: D(e.name),
		amount: E(e.amount),
		lots: E(e.lots)
	};
}
function vn(e) {
	return {
		data: e.data.map(_n),
		remaining: {
			total: e.remaining.total,
			amount: E(e.remaining.amount),
			lots: E(e.remaining.lots)
		}
	};
}
//#endregion
//#region src/lib/api/mappers/subIbs.ts
function yn(e) {
	return e.data;
}
function bn(e, t) {
	return {
		value: e,
		delta: Et(t)
	};
}
function xn(e, t) {
	return {
		value: xt(e),
		delta: Et(t)
	};
}
function Sn(e, t) {
	return {
		rowKey: `${e.name}-${t}`,
		name: D(e.name),
		email: e.email,
		level: e.level,
		clients: e.clients,
		totalDepositAmount: xn(e.total_deposit_amount, e.total_deposit_amount_delta),
		totalDeposits: bn(e.total_deposits, e.total_deposits_delta),
		averageDepositAmount: xt(e.average_deposit_amount),
		netDeposits: xn(e.net_deposits, e.net_deposits_delta),
		totalRebate: xn(e.total_rebate, e.total_rebate_delta)
	};
}
//#endregion
//#region src/lib/api/mappers/switchBonus.ts
function Cn(e) {
	return Be(Le(e, "UTC"));
}
function wn(e) {
	return Be(Le(e, "UTC").subtract({ milliseconds: 1 }));
}
function Tn(e) {
	return {
		newFtdClients: Math.floor(e.new_ftd_clients),
		netDepositUsd: e.net_deposit_usd,
		tradingVolumeUsd: e.trading_volume_usd
	};
}
function En(e) {
	return {
		name: e.name,
		amount: e.amount,
		targets: Tn(e.targets)
	};
}
function Dn(e) {
	return !e || !e.code || !e.from || !e.to || !e.progress || !e.tiers || e.tiers.length === 0 ? null : {
		code: e.code,
		from: Cn(e.from),
		to: wn(e.to),
		progress: Tn(e.progress),
		tiers: e.tiers.map(En).sort((e, t) => e.amount - t.amount)
	};
}
//#endregion
//#region src/lib/api/paths.ts
var On = "/api/v1", kn = "/programs", An = "/impersonate", jn = "client_id", Mn = "external_id", Nn = "sort_by", Pn = 1e3, Fn = "type", In = "type", Ln = "logic", Rn = [
	"id",
	"email",
	"name"
], zn = ["name", "email"], Bn = [
	"name",
	"email",
	"symbol",
	"account"
], Vn = {
	rebate: "rebate",
	balance: "balance",
	netDeposits: "net_deposits"
}, O = {
	leaderboard: "/dashboard/leaderboard",
	topSubIbs: "/dashboard/top-sub-ibs",
	commissions: "/dashboard/commissions",
	monthSummary: "/dashboard/month-summary",
	clients: "/clients",
	subIbs: "/clients/sub-ibs",
	subIbLevels: "/clients/sub-ibs/levels",
	rebates: "/rebates",
	rebatesTotalVolume: "/kpi/rebates/total-volume",
	rebatesTotalRebates: "/kpi/rebates/total-rebates",
	rebatesTopSymbol: "/kpi/rebates/top-symbol",
	rebatesTopClient: "/kpi/rebates/top-client",
	dashboardYesterdayRebate: "/kpi/dashboard/yesterday-rebate",
	dashboardActiveClients: "/kpi/dashboard/active-clients",
	dashboardNetDeposits: "/kpi/dashboard/net-deposits",
	rebateBreakdown: "/rebates/breakdown",
	rebateLevels: "/rebates/levels",
	switchBonus: "/campaigns/switch_bonus"
};
//#endregion
//#region src/lib/api/searchFilters.ts
function Hn(e) {
	return `filter[${e}][like]`;
}
function Un(e) {
	return e.replace(/[,[\]]/g, " ").replace(/\s+/g, " ").trim();
}
function Wn(e, t) {
	let n = Un(t ?? "").toLowerCase();
	if (n === "") return {};
	let r = e.map((e) => `${Hn(e)}=${n}`);
	return { [Ln]: `or[${r.join(",")}]` };
}
function Gn(e) {
	return Wn(Rn, e);
}
function Kn(e) {
	return Wn(Bn, e);
}
function qn(e) {
	return Wn(zn, e);
}
//#endregion
//#region src/lib/api/createIbApi.ts
function Jn(e) {
	let t = Object.entries(e).filter(([, e]) => e !== void 0 && e !== "");
	return Object.fromEntries(t);
}
function Yn(e) {
	return {
		...e,
		tz: w()
	};
}
function Xn({ search: e, levels: t, ...n }) {
	return {
		...n,
		levels: t?.join(","),
		...Kn(e)
	};
}
function Zn({ search: e, levels: t, ...n }) {
	return Yn({
		...n,
		levels: t?.join(","),
		...qn(e)
	});
}
function Qn({ http: e, baseUrl: t }) {
	async function n(n, r, i = {}, a) {
		try {
			return r(await e.request({
				method: "GET",
				path: `${t}${On}${n}`,
				params: Jn(i),
				signal: a
			}));
		} catch (e) {
			throw Oe(e);
		}
	}
	function r(e, t, r, i = {}, a) {
		return n(O[e], r, {
			[jn]: t,
			...i
		}, a);
	}
	async function i(e, t, n, i, a) {
		let o = [], s = !1;
		for (; !s;) {
			let c = o.length, l = await r(e, t, (e) => Dt(e, (e, t) => n(e, c + t)), {
				...i,
				limit: Pn,
				offset: c
			}, a);
			o.push(...l.data), s = l.data.length === 0 || o.length >= l.total;
		}
		return o;
	}
	return {
		getPrograms: (e, t) => n(kn, Qt, { [Mn]: e }, t),
		getImpersonate: (e) => n(An, Zt, {}, e),
		getYesterdayRebate: (e, t) => r("dashboardYesterdayRebate", e, Gt, {}, t),
		getActiveClients: (e, t, n) => r("dashboardActiveClients", e, Kt, Yn(t), n),
		getNetDeposits: (e, t, n) => r("dashboardNetDeposits", e, qt, Yn(t), n),
		getLeaderboard: (e, { type: t, sortBy: n, ...i }, a) => r("leaderboard", e, Yt, {
			[Fn]: t,
			[Nn]: Vn[n],
			...i
		}, a),
		getTopSubIbs: (e, { type: t, ...n }, i) => r("topSubIbs", e, Xt, Yn({
			[Fn]: t,
			...n
		}), i),
		getCalendar: (e, t, n) => r("commissions", e, kt, t, n),
		getMonthSummary: (e, t, n) => r("monthSummary", e, At, { date: t }, n),
		getClients: (e, { search: t, ...n }, i) => r("clients", e, (e) => Dt(e, Wt), {
			...n,
			...Gn(t)
		}, i),
		getSubIbs: (e, t, n) => r("subIbs", e, (e) => Dt(e, Sn), Zn(t), n),
		getSwitchBonus: (e, t, n) => r("switchBonus", e, Dn, t, n),
		getSubIbLevels: (e, t) => r("subIbLevels", e, yn, {}, t),
		getRebates: (e, t, n) => r("rebates", e, (e) => Dt(e, ln), Xn(t), n),
		getRebateLevels: (e, t, n) => r("rebateLevels", e, gn, t, n),
		getRebatesTotalVolume: (e, t, n) => r("rebatesTotalVolume", e, un, t, n),
		getRebatesTotalRebates: (e, t, n) => r("rebatesTotalRebates", e, dn, t, n),
		getRebatesTopSymbol: (e, t, n) => r("rebatesTopSymbol", e, mn, t, n),
		getRebatesTopClient: (e, t, n) => r("rebatesTopClient", e, hn, t, n),
		getRebateBreakdown: (e, { type: t, ...n }, i) => r("rebateBreakdown", e, vn, {
			[In]: t,
			...n
		}, i),
		getAllClients: (e, { search: t, ...n }, r) => i("clients", e, Wt, {
			...n,
			...Gn(t)
		}, r),
		getAllSubIbs: (e, t, n) => i("subIbs", e, Sn, Zn(t), n),
		getAllRebates: (e, t, n) => i("rebates", e, ln, Xn(t), n)
	};
}
//#endregion
//#region src/lib/mocks/money.ts
var $n = 100;
function k(e) {
	return e / $n;
}
function er(e) {
	return e.reduce((e, t) => e + t, 0);
}
//#endregion
//#region src/lib/mocks/random.ts
function tr(e) {
	let t = e;
	return () => {
		t = t + 1831565813 | 0;
		let e = Math.imul(t ^ t >>> 15, 1 | t);
		return e = e + Math.imul(e ^ e >>> 7, 61 | e) ^ e, ((e ^ e >>> 14) >>> 0) / 4294967296;
	};
}
function A(e, t, n) {
	return t + Math.floor(e() * (n - t + 1));
}
function nr(e, t) {
	return t[A(e, 0, t.length - 1)];
}
//#endregion
//#region src/lib/mocks/fixtures/programs.ts
var rr = "42500", ir = [{
	client_id: "01a0a95a-a612-7067-8404-000000000001",
	name: "Advanced"
}, {
	client_id: "01a0a95a-a612-7067-8404-000000000002",
	name: "Elite VIP#"
}];
//#endregion
//#region src/lib/mocks/fixtures/subIbs.ts
function j(e, t) {
	return {
		value: e,
		unit: "percent",
		trend: t
	};
}
function M(e, t) {
	return {
		value: e,
		unit: "count",
		trend: t
	};
}
var ar = [
	{
		joinedDaysAgo: 540,
		row: {
			name: "WIFI MONEY CLUB",
			email: "partners@wifimoney.example.com",
			level: 1,
			clients: 142,
			total_deposit_amount: 486320,
			total_deposit_amount_delta: j(18.4, "positive"),
			total_deposits: 318,
			total_deposits_delta: M(27, "positive"),
			average_deposit_amount: 1529,
			net_deposits: 262410,
			net_deposits_delta: j(9.6, "positive"),
			total_rebate: 4182.4,
			total_rebate_delta: j(14.2, "positive")
		}
	},
	{
		joinedDaysAgo: 420,
		row: {
			name: "OKAN ATASOY",
			email: "okan.atasoy@example.com",
			level: 1,
			clients: 86,
			total_deposit_amount: 201540,
			total_deposit_amount_delta: j(6.1, "negative"),
			total_deposits: 164,
			total_deposits_delta: M(9, "negative"),
			average_deposit_amount: 1229,
			net_deposits: 118260,
			net_deposits_delta: j(11.3, "negative"),
			total_rebate: 1120.65,
			total_rebate_delta: j(3.8, "positive")
		}
	},
	{
		joinedDaysAgo: 380,
		row: {
			name: "ALEXANDER SCHREIBER",
			email: "a.schreiber@example.com",
			level: 1,
			clients: 61,
			total_deposit_amount: 164880,
			total_deposit_amount_delta: j(2.4, "positive"),
			total_deposits: 132,
			total_deposits_delta: M(4, "positive"),
			average_deposit_amount: 1249,
			net_deposits: 92140,
			net_deposits_delta: j(1.7, "negative"),
			total_rebate: 960.2,
			total_rebate_delta: j(5.9, "negative")
		}
	},
	{
		joinedDaysAgo: 300,
		row: {
			name: "JONAS BINOV",
			email: "jonas.binov@example.com",
			level: 1,
			clients: 44,
			total_deposit_amount: 128410,
			total_deposit_amount_delta: j(12.5, "positive"),
			total_deposits: 96,
			total_deposits_delta: M(6, "positive"),
			average_deposit_amount: 1337,
			net_deposits: 74520,
			net_deposits_delta: j(7.1, "positive"),
			total_rebate: 742.8,
			total_rebate_delta: j(9.4, "positive")
		}
	},
	{
		joinedDaysAgo: 260,
		row: {
			name: "M-SHIFT GLOBAL GMBH",
			email: "office@m-shift.example.com",
			level: 2,
			clients: 28,
			total_deposit_amount: 86240,
			total_deposit_amount_delta: j(4.3, "negative"),
			total_deposits: 61,
			total_deposits_delta: M(0, "neutral"),
			average_deposit_amount: 1414,
			net_deposits: 51180,
			net_deposits_delta: j(2.2, "negative"),
			total_rebate: 515.35,
			total_rebate_delta: j(1.6, "negative")
		}
	},
	{
		joinedDaysAgo: 200,
		row: {
			name: "LARYSA M. REISWICH",
			email: "larysa.reiswich@example.com",
			level: 2,
			clients: 17,
			total_deposit_amount: 42910,
			total_deposit_amount_delta: j(22, "positive"),
			total_deposits: 34,
			total_deposits_delta: M(5, "positive"),
			average_deposit_amount: 1262,
			net_deposits: 24660,
			net_deposits_delta: j(15.4, "positive"),
			total_rebate: 268.9,
			total_rebate_delta: j(18.7, "positive")
		}
	},
	{
		joinedDaysAgo: 75,
		row: {
			name: "FX SIGNALS HUB",
			email: "desk@fxsignalshub.example.com",
			level: 2,
			clients: 11,
			total_deposit_amount: 28470,
			total_deposit_amount_delta: j(31, "positive"),
			total_deposits: 22,
			total_deposits_delta: M(4, "positive"),
			average_deposit_amount: 1294,
			net_deposits: 16340,
			net_deposits_delta: j(26, "positive"),
			total_rebate: 174.6,
			total_rebate_delta: j(28.4, "positive")
		}
	},
	{
		joinedDaysAgo: 12,
		row: {
			name: "ANNA KOVACS",
			email: "anna.kovacs@example.com",
			level: 2,
			clients: 6,
			total_deposit_amount: 14220,
			total_deposit_amount_delta: j(100, "positive"),
			total_deposits: 12,
			total_deposits_delta: M(12, "positive"),
			average_deposit_amount: 1185,
			net_deposits: 8940,
			net_deposits_delta: j(100, "positive"),
			total_rebate: 92.15,
			total_rebate_delta: j(100, "positive")
		}
	}
], or = 60, sr = 20260917, cr = 41e3, lr = 75, ur = 43e3, dr = {
	parent_ib_external_id: rr,
	parent_ib_name: "MARCUS HALE",
	parent_ib_email: "marcus.hale@example.com"
}, fr = ar.map(({ row: e }, t) => ({
	parent_ib_external_id: String(ur + t),
	parent_ib_name: e.name,
	parent_ib_email: e.email
})), pr = {
	parent_ib_external_id: "43900",
	parent_ib_name: "",
	parent_ib_email: "unnamed.partner@example.com"
};
function mr(e) {
	let t = fr.find((t) => t.parent_ib_name === e);
	if (t === void 0) throw Error(`No mock sub-IB ${e}`);
	return t;
}
var hr = [
	"MEHMET",
	"ANNA",
	"LUKAS",
	"SOFIA",
	"JONAS",
	"MARIA",
	"OKAN",
	"ELENA",
	"PAVEL",
	"NORA"
], gr = [
	"YILMAZ",
	"KOVACS",
	"WEBER",
	"ROSSI",
	"NOVAK",
	"SILVA",
	"DEMIR",
	"MEYER",
	"HORVAT",
	"LIND"
], _r = [
	{
		externalId: "42680",
		name: "SEBASTIAN S. MROZ",
		email: "seba301.yt@gmail.com",
		volumeLotCents: 0,
		rewardCents: 0,
		status: "inactive",
		balanceCents: 0,
		parent: mr("WIFI MONEY CLUB"),
		subClients: 0,
		registeredDaysAgo: 0,
		netDepositsCents: null,
		lastTradeDaysAgo: null
	},
	{
		externalId: "42606",
		name: "HALIL IBRAHIM ABAK",
		email: "halil.abak@example.com",
		volumeLotCents: 55040,
		rewardCents: 41280,
		status: "active",
		balanceCents: 512085,
		parent: dr,
		subClients: 4,
		registeredDaysAgo: 2,
		netDepositsCents: 1842e3,
		lastTradeDaysAgo: 0
	},
	{
		externalId: "42591",
		name: "DERYA KAPLAN",
		email: "derya.kaplan@example.com",
		volumeLotCents: 34260,
		rewardCents: 25700,
		status: "lowActivity",
		balanceCents: 310,
		parent: dr,
		subClients: 3,
		registeredDaysAgo: 3,
		netDepositsCents: -48500,
		lastTradeDaysAgo: 65
	},
	{
		externalId: "42577",
		name: null,
		email: "trader.no.name@example.com",
		volumeLotCents: 21475,
		rewardCents: 16106,
		status: "active",
		balanceCents: 243010,
		parent: mr("OKAN ATASOY"),
		subClients: 1,
		registeredDaysAgo: 4,
		netDepositsCents: null,
		lastTradeDaysAgo: 1
	},
	{
		externalId: "42560",
		name: "PETRA LANG",
		email: "petra.lang@example.com",
		volumeLotCents: 9630,
		rewardCents: 7222,
		status: "active",
		balanceCents: 98e3,
		parent: dr,
		subClients: 0,
		registeredDaysAgo: 5,
		netDepositsCents: 0,
		lastTradeDaysAgo: 0
	},
	{
		externalId: "42548",
		name: "LARS DOMINIK REICHERT",
		email: "lars.reichert@example.com",
		volumeLotCents: 50670,
		rewardCents: 38e3,
		status: "lowActivity",
		balanceCents: 259,
		parent: dr,
		subClients: 0,
		registeredDaysAgo: 5,
		netDepositsCents: -32e3,
		lastTradeDaysAgo: 45
	},
	{
		externalId: "42533",
		name: "IVAN PETROV",
		email: "ivan.petrov@example.com",
		volumeLotCents: 0,
		rewardCents: 0,
		status: "inactive",
		balanceCents: 0,
		parent: pr,
		subClients: 0,
		registeredDaysAgo: 5,
		netDepositsCents: null,
		lastTradeDaysAgo: null
	}
], vr = new Ae(13, 31, 58);
function yr(e, t) {
	return `${y(e.subtract({ days: t }), vr).toString()}Z`;
}
function br(e, t) {
	return {
		row: {
			external_id: e.externalId,
			name: e.name,
			email: e.email,
			volume_lots: k(e.volumeLotCents),
			rewards: k(e.rewardCents),
			status: Ht[e.status],
			balance: k(e.balanceCents),
			...e.parent,
			sub_clients: e.subClients,
			registered_at: yr(t, e.registeredDaysAgo)
		},
		netDepositsCents: e.netDepositsCents,
		lastTradeDaysAgo: e.lastTradeDaysAgo
	};
}
function xr(e, t) {
	return e < t ? "active" : e < t + or ? "lowActivity" : "inactive";
}
function Sr(e, t, n, r) {
	let i = nr(e, hr), a = nr(e, gr), o = n !== "inactive", s = o ? A(e, 500, 4e4) : 0, c = o ? A(e, 2e4, 9e5) : 0, l = n === "active" ? A(e, 0, 6) : A(e, 20, 60);
	return {
		row: {
			external_id: String(cr - t),
			name: `${i} ${a}`,
			email: `${i}.${a}${t}@example.com`.toLowerCase(),
			volume_lots: k(s),
			rewards: k(Math.round(s * lr / 100)),
			status: Ht[n],
			balance: k(c),
			...e() < .6 ? dr : nr(e, fr),
			sub_clients: e() < .85 ? 0 : A(e, 1, 5),
			registered_at: yr(r, A(e, 6, 700))
		},
		netDepositsCents: o ? A(e, -5e4, 25e5) : null,
		lastTradeDaysAgo: o ? l : null
	};
}
function Cr(e) {
	let t = tr(sr), n = _r.map((t) => br(t, e)), r = n.filter((e) => e.row.status === "active").length, i = 433 - n.length, a = [];
	for (let n = 0; n < i; n += 1) {
		let i = xr(n, 286 - r);
		a.push(Sr(t, n, i, e));
	}
	return [...n, ...a];
}
var wr = 5001, Tr = 18e3, Er = 9e3, Dr = 28e3, Or = 1200, kr = .04, Ar = .12, jr = .7, Mr = "en-US", Nr = 0, Pr = 6;
function Fr(e, t, n) {
	return Math.min(n, Math.max(t, e));
}
function Ir(e) {
	let t = tr(wr), n = [], r = Tr;
	for (let i = 400; i >= 1; --i) {
		let a = e.subtract({ days: i }), o = Ne(a, Mr), s = o === Nr || o === Pr, c = (t() * 2 - 1) * Or, l = (Tr - r) * kr;
		r = Fr(r + c + l, Er, Dr);
		let u = 1 + (t() * 2 - 1) * Ar;
		n.push({
			date: a.toString(),
			cents: Math.round(r * u * (s ? jr : 1))
		});
	}
	return n;
}
//#endregion
//#region src/lib/mocks/fixtures/rebates.ts
var Lr = 20261021, Rr = [
	"XAUUSD",
	"EURUSD",
	"BTCUSDT",
	"GBPUSD",
	"NAS100",
	"USDJPY",
	"XAGUSD",
	"AUDCAD",
	"USDCHF",
	"EURGBP"
], zr = [
	100,
	120,
	80
], Br = .3, Vr = {
	XAUUSD: 412503,
	EURUSD: 116210,
	BTCUSDT: 108200,
	GBPUSD: 132820,
	NAS100: 25050,
	USDJPY: 1e5,
	XAGUSD: 241250,
	AUDCAD: 65200,
	USDCHF: 1e5,
	EURGBP: 116210
}, Hr = [
	{
		externalId: "42680",
		name: "ELIF DEMIRCAN",
		email: "elif.demircan@example.com",
		accountId: "70113",
		level: 1
	},
	{
		externalId: "42606",
		name: "JONAS WEBER",
		email: "jonas.weber@example.com",
		accountId: "70245",
		level: 1
	},
	{
		externalId: "42591",
		name: "LEO MARTIN",
		email: "leo.martin@example.com",
		accountId: "70388",
		level: 2
	},
	{
		externalId: "42577",
		name: "",
		email: "trader.no.name@example.com",
		accountId: "70402",
		level: 1
	},
	{
		externalId: "42560",
		name: "ZOFIA NOWAK",
		email: "zofia.nowak@example.com",
		accountId: "70517",
		level: 2
	},
	{
		externalId: "42548",
		name: "BLUE HARBOR CAPITAL LTD",
		email: "desk@blueharbor.example.com",
		accountId: "70621",
		level: 1
	},
	{
		externalId: "42533",
		name: "IVAN PETROV",
		email: "ivan.petrov@example.com",
		accountId: "70734",
		level: 2
	},
	{
		externalId: "42519",
		name: "DERYA KAPLAN",
		email: "derya.kaplan@example.com",
		accountId: "70859",
		level: 1
	},
	{
		externalId: "42504",
		name: "LUKAS NOVAK",
		email: "lukas.novak@example.com",
		accountId: "70966",
		level: 2
	},
	{
		externalId: "42491",
		name: "SOFIA ROSSI",
		email: "sofia.rossi@example.com",
		accountId: "71078",
		level: 1
	},
	{
		externalId: "42476",
		name: "OKAN YILMAZ",
		email: "okan.yilmaz@example.com",
		accountId: "71183",
		level: 3
	},
	{
		externalId: "42462",
		name: "NORA LIND",
		email: "nora.lind@example.com",
		accountId: "71297",
		level: 1
	}
];
function Ur(e) {
	return (e() < Br ? A(e, 1, 99) : A(e, 100, 12e3)) / 1e4;
}
function Wr(e, t) {
	let n = nr(e, Hr), r = y(t, new Ae(A(e, 0, 23), A(e, 0, 59), A(e, 0, 59))), i = nr(e, an), a = nr(e, Rr), o = A(e, 1, 200) / 100;
	return {
		client_id: n.externalId,
		name: n.name,
		email: n.email,
		level: n.level,
		account: n.accountId,
		side: i,
		symbol: a,
		lots: o,
		volume: Math.round(o * Vr[a] * 100) / 100,
		rewards: Ur(e),
		traded_at: bt(r, w())
	};
}
function Gr(e) {
	let t = tr(Lr), n = [], r = e.set({ day: 1 });
	return zr.forEach((i, a) => {
		let o = r.subtract({ months: a }), s = a === 0 ? e.day : o.calendar.getDaysInMonth(o);
		for (let e = 0; e < i; e += 1) {
			let e = o.set({ day: A(t, 1, s) });
			n.push(Wr(t, e));
		}
	}), n;
}
//#endregion
//#region src/lib/mocks/fixtures/programData.ts
function Kr() {
	return {
		clients: [],
		subIbs: [],
		daily: [],
		rebates: [],
		topPair: null
	};
}
function qr(e, t, n) {
	return e !== "01a0a95a-a612-7067-8404-000000000001" && e !== "01a0a95a-a612-7067-8404-000000000002" ? null : t === "empty" || e === "01a0a95a-a612-7067-8404-000000000002" ? Kr() : {
		clients: Cr(n),
		subIbs: ar,
		daily: Ir(n),
		rebates: Gr(n),
		topPair: "XAUUSD"
	};
}
//#endregion
//#region src/lib/mocks/mockHttpError.ts
var N = class extends Error {
	response;
	constructor(e, t, n) {
		super(n), this.name = "MockHttpError", this.response = {
			status: e,
			data: { errors: [{
				detail: n,
				error_code: t,
				status: e,
				title: n
			}] }
		};
	}
};
function Jr() {
	return new DOMException("The request was aborted", "AbortError");
}
//#endregion
//#region src/lib/mocks/handlers/compare.ts
function P(e, t) {
	return e - t;
}
function Yr(e, t, n) {
	return e === null && t === null ? 0 : e === null ? 1 : t === null ? -1 : n(e, t);
}
function Xr(e, t, n) {
	let r = n === "asc" ? 1 : -1;
	return [...e].sort((e, n) => r * t(e, n));
}
//#endregion
//#region src/lib/mocks/handlers/context.ts
function F(e, t) {
	let n = e[t];
	return n === void 0 ? void 0 : String(n);
}
function Zr(e, t, n) {
	let r = Number(e[t]);
	return Number.isFinite(r) ? r : n;
}
function Qr(e) {
	return (F(e, "levels") ?? "").split(",").map((e) => e.trim()).filter((e) => e !== "").map((e) => {
		let t = Number(e);
		if (!Number.isInteger(t)) throw new N(400, "bad_request", "levels must be numbers");
		return t;
	});
}
function $r(e) {
	let t = F(e, "sortOrder");
	return jt.find((e) => e === t) ?? "desc";
}
function ei(e, t) {
	let n = Zr(t, "limit", 10), r = Zr(t, "offset", 0);
	return {
		total: e.length,
		data: e.slice(r, r + n)
	};
}
var ti = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})$/;
function ni(e, t) {
	let n = F(e, t);
	if (n !== void 0) {
		if (!ti.test(n)) throw new N(400, "bad_request", `invalid ${t}`);
		try {
			return y(Le(n, "UTC"));
		} catch {
			throw new N(400, "bad_request", `invalid ${t}`);
		}
	}
}
function I(e, t) {
	let n = ni(e, t);
	return n === void 0 ? void 0 : yt(n.toString());
}
function ri(e, t) {
	if (e !== void 0 && t !== void 0 && e.compare(t) > 0) throw new N(400, "bad_request", "from must be before to");
}
//#endregion
//#region src/lib/mocks/handlers/calendar.ts
var ii = /^\d{4}-\d{2}-\d{2}$/;
function ai(e) {
	let t = F(e, "date") ?? "";
	if (!ii.test(t)) throw new N(400, "bad_request", "date must be in YYYY-MM-DD format");
	try {
		let e = Re(t);
		return new ke(e.year, e.month, 1);
	} catch {
		throw new N(400, "bad_request", "date must be in YYYY-MM-DD format");
	}
}
function oi(e, t, n) {
	let r = n.calendar.getDaysInMonth(n), i = new Map(e.daily.map((e) => [e.date, e.cents])), a = [];
	for (let e = 0; e < r; e += 1) {
		let r = n.add({ days: e });
		if (r.compare(t) > 0) break;
		a.push({
			date: r.toString(),
			cents: i.get(r.toString()) ?? 0
		});
	}
	return a;
}
function si(e) {
	return {
		date: e.date,
		value: k(e.cents)
	};
}
function ci(e, t, n, r) {
	if (e.lastTradeDaysAgo === null) return !1;
	let i = t.subtract({ days: e.lastTradeDaysAgo }).toString();
	return i >= n && i <= r;
}
function li(e) {
	let { data: t, query: n, today: r } = e, i = ni(n, "from"), a = ni(n, "to");
	if (i === void 0 || a === void 0) throw new N(400, "bad_request", "from and to are required");
	let o = Be(i), s = new ke(o.year, o.month, 1), c = s.calendar.getDaysInMonth(s), l = s.add({ days: c - 1 }), u = o.compare(s) === 0 && ui(i, 0, 0, 0), d = Be(a).compare(l) === 0 && ui(a, 23, 59, 59);
	if (!u || !d) throw new N(400, "bad_request", "from and to must span a whole month");
	return { data: oi(t, r, s).map(si) };
}
function ui(e, t, n, r) {
	return e.hour === t && e.minute === n && e.second === r;
}
function di(e) {
	let { data: t, today: n, query: r } = e, i = oi(t, n, ai(r)), a = er(i.map((e) => e.cents));
	if (a === 0) return {
		total_commission_amount: 0,
		best_day_date: "",
		best_day_amount: 0,
		top_pair: "",
		top_client_name: ""
	};
	let o = i[0].date, s = i[i.length - 1].date, c = i.reduce((e, t) => t.cents > e.cents ? t : e), [l] = Xr(t.clients.filter((e) => ci(e, n, o, s)), (e, t) => P(e.row.rewards, t.row.rewards), "desc");
	return {
		total_commission_amount: k(a),
		best_day_date: c.date,
		best_day_amount: k(c.cents),
		top_pair: t.topPair ?? "",
		top_client_name: l?.row.name ?? ""
	};
}
//#endregion
//#region src/lib/mocks/fixtures/switchBonus.ts
var fi = "tier1Blocked", pi = {
	zero: {
		new_ftd_clients: 0,
		net_deposit_usd: 0,
		trading_volume_usd: 0
	},
	tier1Blocked: {
		new_ftd_clients: 12,
		net_deposit_usd: 32e3,
		trading_volume_usd: 66e6
	},
	tier2Next: {
		new_ftd_clients: 14,
		net_deposit_usd: 64e3,
		trading_volume_usd: 52e6
	},
	tier3Next: {
		new_ftd_clients: 32,
		net_deposit_usd: 15e4,
		trading_volume_usd: 55e6
	},
	allMet: {
		new_ftd_clients: 45,
		net_deposit_usd: 23e4,
		trading_volume_usd: 61e6
	}
}, mi = [
	{
		name: "Tier 1",
		amount: 2e3,
		targets: {
			new_ftd_clients: 10,
			net_deposit_usd: 5e4,
			trading_volume_usd: 3e7
		}
	},
	{
		name: "Tier 2",
		amount: 5e3,
		targets: {
			new_ftd_clients: 20,
			net_deposit_usd: 1e5,
			trading_volume_usd: 4e7
		}
	},
	{
		name: "Tier 3",
		amount: 1e4,
		targets: {
			new_ftd_clients: 40,
			net_deposit_usd: 2e5,
			trading_volume_usd: 5e7
		}
	}
];
function hi(e) {
	return {
		code: "switch_bonus",
		from: "2026-10-01T00:00:00Z",
		to: "2027-03-31T23:00:00Z",
		progress: pi[e],
		tiers: mi
	};
}
//#endregion
//#region src/lib/mocks/handlers/campaigns.ts
function gi({ query: e }) {
	return F(e, "client_id") === "01a0a95a-a612-7067-8404-000000000002" ? {} : hi(fi);
}
//#endregion
//#region src/lib/model/dashboard.ts
var _i = [
	"all",
	"direct",
	"indirect"
], vi = [
	"rebate",
	"balance",
	"netDeposits"
], yi = 5, bi = 14.73, xi = 5.8, Si = .688, Ci = 100, wi = 100;
function Ti(e) {
	return e > 0 ? "positive" : e < 0 ? "negative" : "neutral";
}
function Ei(e, t) {
	if (t === 0) return null;
	let n = (e - t) / Math.abs(t) * Ci;
	return {
		value: Math.round(Math.abs(n) * wi) / wi,
		trend: Ti(n),
		unit: "percent"
	};
}
function Di(e, t, n) {
	return e.filter((e) => (t === void 0 || e.date >= t) && (n === void 0 || e.date <= n));
}
function Oi(e) {
	let t = I(e, "from"), n = I(e, "to");
	if (t === void 0 || n === void 0) throw new N(400, "bad_request", "from and to are required");
	return ri(t, n), {
		from: t,
		to: n
	};
}
function ki(e, t, n) {
	let r = t.subtract({ days: 1 }), i = r.subtract({ days: n.compare(t) });
	return {
		current: er(Di(e, t.toString(), n.toString()).map((e) => e.cents)),
		previous: er(Di(e, i.toString(), r.toString()).map((e) => e.cents))
	};
}
function Ai({ data: e, today: t }) {
	let n = t.subtract({ days: 1 }), r = e.daily.find((e) => e.date === n.toString());
	return {
		amount: r ? k(r.cents) : 0,
		date: n.toString()
	};
}
function ji({ data: e, query: t }) {
	let { from: n, to: r } = Oi(t), { previous: i } = ki(e.daily, n, r), a = e.clients.filter((e) => e.row.status === "active").length, o = i === 0 ? 0 : Math.round(a * Si);
	return {
		active: a,
		network_total: e.clients.length,
		low_activity: e.clients.filter((e) => e.row.status === Ht.lowActivity).length,
		delta: Ei(a, o)
	};
}
function Mi(e) {
	return {
		in: Math.round(e * bi),
		out: Math.round(e * xi)
	};
}
function Ni({ data: e, query: t }) {
	let { from: n, to: r } = Oi(t), { current: i, previous: a } = ki(e.daily, n, r), o = Mi(i), s = Mi(a);
	return {
		in: k(o.in),
		out: k(o.out),
		net: k(o.in - o.out),
		delta: Ei(o.in - o.out, s.in - s.out)
	};
}
var Pi = new Ae(9, 14, 0);
function Fi(e, t) {
	return `${y(e.subtract({ days: t }), Pi).toString()}Z`;
}
function Ii(e) {
	let t = F(e, Fn);
	if (t === void 0) return;
	let n = _i.find((e) => e === t);
	if (n === void 0) throw new N(400, "bad_request", `invalid ${Fn}`);
	return n;
}
function Li(e, t) {
	if (t === "all") return !0;
	let n = e.row.parent_ib_external_id === rr;
	return t === "direct" ? n : !n;
}
function Ri({ row: e }, t) {
	return t === "all" ? !0 : t === "direct" ? e.level === 1 : e.level > 1;
}
var zi = {
	rebate: (e, t) => P(t.row.rewards, e.row.rewards),
	balance: (e, t) => P(t.row.balance, e.row.balance),
	netDeposits: (e, t) => P(t.netDepositsCents ?? 0, e.netDepositsCents ?? 0)
};
function Bi(e, t) {
	let { lastTradeDaysAgo: n, netDepositsCents: r, row: i } = e;
	return {
		name: i.name ?? "",
		email: i.email,
		rewards: i.rewards,
		balance: i.balance,
		net_deposits: k(r ?? 0),
		last_trade_at: n === null ? null : Fi(t, n),
		status: i.status
	};
}
function Vi({ data: e, query: t, today: n }) {
	ri(ni(t, "from"), ni(t, "to"));
	let r = Ii(t), i = F(t, Nn), a = vi.find((e) => Vn[e] === i);
	if (r === void 0) throw new N(400, "bad_request", `${Fn} is required`);
	if (a === void 0) throw new N(400, "bad_request", `invalid ${Nn}`);
	let o = e.clients.filter((e) => e.lastTradeDaysAgo !== null && Li(e, r)), s = Xr(o, zi[a], "asc").slice(0, yi);
	return {
		total: o.length,
		data: s.map((e) => Bi(e, n))
	};
}
function Hi(e) {
	return {
		current: e,
		previous: 0,
		change_pct: 0
	};
}
function Ui({ data: e, query: t }) {
	ri(ni(t, "from"), ni(t, "to"));
	let n = Ii(t) ?? "all", r = e.subIbs.filter((e) => Ri(e, n)), i = Xr(r, (e, t) => P(e.row.total_rebate ?? 0, t.row.total_rebate ?? 0), "desc").slice(0, yi);
	return {
		total: r.length,
		data: i.map(({ row: e }) => ({
			name: e.name,
			email: e.email,
			level: e.level,
			clients: e.clients ?? 0,
			rewards: Hi(e.total_rebate ?? 0),
			volume_lots: Hi(0)
		}))
	};
}
//#endregion
//#region src/lib/model/subIbs.ts
var Wi = [
	"totalRebate",
	"clients",
	"totalDepositAmount",
	"totalDeposits",
	"averageDepositAmount",
	"netDeposits"
];
function Gi(e, t) {
	let n = tn(e.level, t);
	return {
		levels: n === null || n.length === 0 ? null : n,
		search: Ft(e.search)
	};
}
//#endregion
//#region src/lib/mocks/handlers/search.ts
var Ki = /^or\[(.*)\]$/, qi = /^filter\[([^\]]+)\]\[like\]=(.*)$/;
function Ji(e) {
	let t = Ki.exec(F(e, "logic") ?? "");
	return t === null ? [] : t[1].split(",").flatMap((e) => {
		let t = qi.exec(e);
		if (t === null) return [];
		let [, n, r] = t;
		return [{
			column: n,
			value: r
		}];
	});
}
function Yi(e, t) {
	return e !== null && e.toLocaleLowerCase().includes(t.toLocaleLowerCase());
}
//#endregion
//#region src/lib/mocks/handlers/lists.ts
var Xi = {
	registeredAt: (e, t) => P(Date.parse(e.registered_at), Date.parse(t.registered_at)),
	volumeLots: (e, t) => P(e.volume_lots, t.volume_lots),
	rewards: (e, t) => P(e.rewards, t.rewards),
	balance: (e, t) => P(e.balance, t.balance),
	subClients: (e, t) => P(e.sub_clients, t.sub_clients)
}, Zi = {
	totalRebate: (e) => e.total_rebate,
	clients: (e) => e.clients,
	totalDepositAmount: (e) => e.total_deposit_amount,
	totalDeposits: (e) => e.total_deposits,
	averageDepositAmount: (e) => e.average_deposit_amount,
	netDeposits: (e) => e.net_deposits
}, Qi = {
	total_deposit_amount_delta: null,
	total_deposits_delta: null,
	net_deposits_delta: null,
	total_rebate_delta: null
}, $i = {
	...Qi,
	clients: null,
	total_deposit_amount: null,
	total_deposits: null,
	average_deposit_amount: null,
	net_deposits: null,
	total_rebate: null
};
function ea(e, t, n) {
	let r = Zi[t], i = e.filter((e) => r(e) !== null), a = e.filter((e) => r(e) === null);
	return [...Xr(i, (e, t) => Yr(r(e), r(t), P), n), ...a];
}
var ta = {
	id: (e) => e.external_id,
	email: (e) => e.email,
	name: (e) => e.name
};
function na(e) {
	return Rn.some((t) => t === e);
}
function ra(e) {
	return Ji(e).flatMap(({ column: e, value: t }) => na(e) ? [{
		column: e,
		value: t
	}] : []);
}
function ia({ data: e, query: t }) {
	let n = Lt.find((e) => e === F(t, "status")), r = F(t, "hideZeroCommission") === "true";
	ri(I(t, "from"), I(t, "to"));
	let i = F(t, "sortBy"), a = Rt.find((e) => e === i) ?? "registeredAt", o = ra(t);
	function s(e) {
		return o.length === 0 || o.some(({ column: t, value: n }) => Yi(ta[t](e), n));
	}
	return ei(Xr(e.clients.map((e) => e.row).filter((e) => n === void 0 || e.status === Ht[n]).filter((e) => !r || e.rewards > 0).filter(s), Xi[a], $r(t)), t);
}
function aa(e, t, n) {
	if (n === "day") return e.subtract({ days: t.compare(e) + 1 });
	let r = t.add({ days: 1 }), i = Math.max(1, (r.year - e.year) * 12 + r.month - e.month);
	return e.subtract({ months: i });
}
var oa = {
	name: (e) => e.name,
	email: (e) => e.email
};
function sa(e) {
	return zn.some((t) => t === e);
}
function ca({ data: e, query: t, today: n }) {
	let r = Qr(t), i = I(t, "from"), a = I(t, "to"), o = F(t, "compare");
	ri(i, a);
	let s = F(t, "sortBy"), c = Wi.find((e) => e === s) ?? "totalRebate", l = Ji(t).flatMap(({ column: e, value: t }) => sa(e) ? [{
		column: e,
		value: t
	}] : []);
	function u({ row: e }) {
		return l.length === 0 || l.some(({ column: t, value: n }) => Yi(oa[t](e), n));
	}
	function d({ joinedDaysAgo: e, row: t }) {
		let r = n.subtract({ days: e });
		if (a !== void 0 && a.compare(r) < 0) return {
			...t,
			...$i
		};
		if (i === void 0 || a === void 0) return {
			...t,
			...Qi
		};
		let s = aa(i, a, o);
		return r.compare(s) > 0 ? {
			...t,
			...Qi
		} : t;
	}
	return ei(ea(e.subIbs.filter((e) => r.length === 0 || r.includes(e.row.level)).filter(u).map(d), c, $r(t)), t);
}
function la({ data: e }) {
	let t = [...new Set(e.subIbs.map((e) => e.row.level))].sort((e, t) => e - t);
	return {
		total: t.length,
		data: t
	};
}
//#endregion
//#region src/lib/mocks/handlers/rebates.ts
var ua = {
	tradedAt: (e, t) => P(Date.parse(e.traded_at), Date.parse(t.traded_at)),
	volume: (e, t) => P(e.volume, t.volume),
	rewards: (e, t) => P(e.rewards, t.rewards)
}, da = {
	name: (e) => e.name,
	email: (e) => e.email,
	symbol: (e) => e.symbol,
	account: (e) => e.account
};
function fa(e) {
	return Bn.some((t) => t === e);
}
function pa({ data: e, query: t }) {
	let n = I(t, "from"), r = I(t, "to");
	ri(n, r);
	function i(e) {
		let t = yt(e.traded_at);
		return (n === void 0 || t.compare(n) >= 0) && (r === void 0 || t.compare(r) <= 0);
	}
	return e.rebates.filter(i);
}
function ma(e) {
	let { query: t } = e, n = Qr(t), r = Ji(t).flatMap(({ column: e, value: t }) => fa(e) ? [{
		column: e,
		value: t
	}] : []);
	function i(e) {
		return r.length === 0 || r.some(({ column: t, value: n }) => Yi(da[t](e), n));
	}
	return pa(e).filter((e) => n.length === 0 || n.includes(e.level)).filter(i);
}
function ha(e) {
	return {
		account: e.account,
		email: e.email,
		level: e.level,
		lots: e.lots,
		name: e.name,
		rewards: e.rewards,
		side: e.side,
		symbol: e.symbol,
		traded_at: e.traded_at,
		volume: e.volume
	};
}
function ga(e) {
	let { query: t } = e, n = F(t, "sortBy"), r = rn.find((e) => e === n) ?? "tradedAt", i = ei(Xr(ma(e), ua[r], $r(t)), t);
	return {
		total: i.total,
		data: i.data.map(ha)
	};
}
function _a(e) {
	let t = [...new Set(pa(e).map((e) => e.level))].sort((e, t) => e - t);
	return {
		total: t.length,
		data: t
	};
}
var va = 8, ya = 10 ** 4, ba = 10, xa = 100;
function L(e) {
	return Math.round(e * ya) / ya;
}
function Sa(e, t) {
	return t === 0 ? 0 : Math.round(e / t * xa * ba) / ba;
}
function Ca(e) {
	return e.reduce((e, t) => e + t.lots, 0);
}
function wa(e) {
	return e.reduce((e, t) => e + t.rewards, 0);
}
function Ta(e, t, n) {
	let r = /* @__PURE__ */ new Map();
	for (let i of e) {
		let e = t(i), a = r.get(e) ?? {
			key: n(i),
			amount: 0,
			volume: 0
		};
		a.amount += i.rewards, a.volume += i.lots, r.set(e, a);
	}
	return [...r.values()];
}
function Ea(e) {
	return Ta(e, (e) => e.symbol, (e) => ({ name: e.symbol }));
}
function Da(e) {
	return Ta(e, (e) => e.client_id, (e) => ({ name: e.name }));
}
function Oa(e) {
	return e.reduce((e, t) => e === null || t.volume > e.volume ? t : e, null);
}
function ka(e) {
	let t = pa(e);
	return {
		total_volume: L(Ca(t)),
		total_symbols: Ea(t).length
	};
}
function Aa(e) {
	let t = pa(e), n = Ca(t), r = wa(t);
	return {
		total_rebates: L(r),
		rebates_per_lot: n === 0 ? 0 : L(r / n)
	};
}
function ja(e) {
	let t = pa(e), n = Oa(Ea(t));
	return n === null ? {
		symbol: "",
		total_lots: 0,
		volume_percent: 0
	} : {
		symbol: n.key.name,
		total_lots: L(n.volume),
		volume_percent: Sa(n.volume, Ca(t))
	};
}
function Ma(e) {
	let t = pa(e), n = Oa(Da(t));
	return n === null ? {
		name: "",
		total_lots: 0,
		volume_percent: 0
	} : {
		name: n.key.name,
		total_lots: L(n.volume),
		volume_percent: Sa(n.volume, Ca(t))
	};
}
function Na(e) {
	let t = F(e, In), n = on.find((e) => e === t);
	if (n === void 0) throw new N(400, "bad_request", `type must be either "client" or "pair" got "${t ?? ""}"`);
	return n;
}
function Pa(e) {
	let t = Na(e.query), n = pa(e), r = [...t === "pair" ? Ea(n) : Da(n)].sort((e, t) => t.amount - e.amount), i = r.slice(va);
	return {
		data: r.slice(0, va).map((e) => ({
			name: e.key.name,
			amount: L(e.amount),
			lots: L(e.volume)
		})),
		remaining: {
			total: i.length,
			amount: L(i.reduce((e, t) => e + t.amount, 0)),
			lots: L(i.reduce((e, t) => e + t.volume, 0))
		}
	};
}
//#endregion
//#region src/lib/mocks/createMockIbHttp.ts
var Fa = 300, Ia = {
	[O.leaderboard]: Vi,
	[O.topSubIbs]: Ui,
	[O.commissions]: li,
	[O.monthSummary]: di,
	[O.clients]: ia,
	[O.subIbs]: ca,
	[O.subIbLevels]: la,
	[O.rebates]: ga,
	[O.rebatesTotalVolume]: ka,
	[O.rebatesTotalRebates]: Aa,
	[O.rebatesTopSymbol]: ja,
	[O.rebatesTopClient]: Ma,
	[O.rebateBreakdown]: Pa,
	[O.rebateLevels]: _a,
	[O.dashboardYesterdayRebate]: Ai,
	[O.dashboardActiveClients]: ji,
	[O.dashboardNetDeposits]: Ni,
	[O.switchBonus]: gi
};
function La(e, t) {
	return new Promise((n, r) => {
		if (t?.aborted) {
			r(Jr());
			return;
		}
		let i = setTimeout(n, e);
		t?.addEventListener("abort", () => {
			clearTimeout(i), r(Jr());
		}, { once: !0 });
	});
}
function Ra(e = {}) {
	let t = e.latencyMs ?? Fa, n = e.errorRate ?? 0, r = e.scenario ?? "default", i = e.programs ?? "all", a = /* @__PURE__ */ new Map();
	function o(e, t) {
		let n = `${e}:${t.toString()}`;
		return a.has(n) || a.set(n, qr(e, r, t)), a.get(n) ?? null;
	}
	function s() {
		return i === "none" ? [] : i === "single" ? ir.slice(0, 1) : ir;
	}
	function c(e) {
		let t = e.path.slice(e.path.indexOf(On) + On.length), n = e.params ?? {};
		if (t === "/programs") {
			if (F(n, "external_id") === void 0) throw new N(400, "bad_request", `${Mn} is required`);
			let e = s();
			return {
				total: e.length,
				data: e
			};
		}
		let r = Ia[t];
		if (r === void 0) throw new N(404, "not_found", `No mock for ${t}`);
		let i = F(n, jn);
		if (i === void 0) throw new N(400, "bad_request", `${jn} is required`);
		let a = T(), c = o(i, a);
		if (c === null) throw new N(404, "program_not_found", "Program not found");
		return r({
			data: c,
			query: n,
			today: a
		});
	}
	return { request: async (e) => {
		if (await La(t, e.signal), n > 0 && Math.random() < n) throw new N(503, "upstream_unavailable", "Mocked upstream failure");
		return c(e);
	} };
}
//#endregion
//#region src/lib/context/IbHostConfigContext.tsx
var za = ve(null);
function Ba({ value: e, children: t }) {
	return /* @__PURE__ */ b(za.Provider, {
		value: e,
		children: t
	});
}
function R() {
	let e = be(za);
	if (e === null) throw Error("useIbHostConfig must be used within IbDeskProvider");
	return e;
}
//#endregion
//#region src/lib/context/IbApiContext.tsx
var Va = ve(null);
function Ha({ children: e }) {
	let { http: t, baseUrl: n, isMocksEnabled: r } = R(), i = Ce(() => Qn(r ? {
		http: Ra(),
		baseUrl: ""
	} : {
		http: t,
		baseUrl: n
	}), [
		t,
		n,
		r
	]);
	return /* @__PURE__ */ b(Va.Provider, {
		value: i,
		children: e
	});
}
function z() {
	let e = be(Va);
	if (e === null) throw Error("useIbApi must be used within IbDeskProvider");
	return e;
}
//#endregion
//#region src/lib/query/ibQueryKeys.ts
var Ua = "ib";
function B(e) {
	return [
		Ua,
		"client",
		e
	];
}
var V = {
	all: [Ua],
	programs: (e) => [
		Ua,
		"programs",
		e
	],
	impersonate: (e) => [
		Ua,
		"impersonate",
		e
	],
	client: B,
	yesterdayRebate: (e) => [...B(e), "yesterdayRebate"],
	activeClients: (e, t) => [
		...B(e),
		"activeClients",
		t
	],
	netDeposits: (e, t) => [
		...B(e),
		"netDeposits",
		t
	],
	leaderboard: (e, t, n, r) => [
		...B(e),
		"leaderboard",
		t,
		n,
		r
	],
	topSubIbs: (e, t, n) => [
		...B(e),
		"topSubIbs",
		t,
		n
	],
	calendar: (e, t) => [
		...B(e),
		"calendar",
		t
	],
	monthSummary: (e, t) => [
		...B(e),
		"monthSummary",
		t
	],
	switchBonus: (e, t) => [
		...B(e),
		"switchBonus",
		t
	],
	clients: (e, t) => [
		...B(e),
		"clients",
		t
	],
	subIbs: (e, t) => [
		...B(e),
		"subIbs",
		t
	],
	subIbLevels: (e) => [...B(e), "subIbLevels"],
	rebates: (e, t) => [
		...B(e),
		"rebates",
		t
	],
	rebateLevels: (e, t) => [
		...B(e),
		"rebateLevels",
		t
	],
	rebatesTotalVolume: (e, t) => [
		...B(e),
		"rebatesTotalVolume",
		t
	],
	rebatesTotalRebates: (e, t) => [
		...B(e),
		"rebatesTotalRebates",
		t
	],
	rebatesTopSymbol: (e, t) => [
		...B(e),
		"rebatesTopSymbol",
		t
	],
	rebatesTopClient: (e, t) => [
		...B(e),
		"rebatesTopClient",
		t
	],
	rebateBreakdown: (e, t, n) => [
		...B(e),
		"rebateBreakdown",
		t,
		n
	]
}, Wa = 6e4, Ga = 1;
function Ka(e) {
	let t = e.httpStatus;
	return t !== void 0 && t >= 400 && t < 500;
}
function qa(e, t) {
	return !Ka(t) && e < Ga;
}
var H = {
	staleTime: Wa,
	refetchOnWindowFocus: !1,
	retry: qa
};
//#endregion
//#region src/lib/hooks/programQueries.ts
function Ja(e, { enabled: t }) {
	let n = z();
	return v({
		...H,
		queryKey: V.programs(e ?? ""),
		queryFn: ({ signal: t }) => n.getPrograms(e ?? "", t),
		enabled: t && e !== null
	});
}
//#endregion
//#region src/lib/model/searchParams.ts
function Ya(e, t, n) {
	let r = new URLSearchParams(e);
	for (let e of t) r.delete(e);
	for (let [e, t] of Object.entries(n)) r.set(e, t);
	return r;
}
//#endregion
//#region src/lib/routes/ibHref.ts
var U = {
	overview: "overview",
	clients: "clients",
	subIbs: "sub-ibs",
	rebates: "rebates"
}, Xa = "program";
function Za(e, t, n) {
	return `${e}/${t}${n}`;
}
function Qa(e, t) {
	let n = new URLSearchParams(e);
	for (let [e, r] of Object.entries(t)) r !== void 0 && n.set(e, r);
	let r = n.toString();
	return r === "" ? "" : `?${r}`;
}
function $a(e, t) {
	let n = t[0];
	if (n === void 0) return null;
	let r = e.get(Xa), i = t.find((e) => e.clientId === r);
	return i === void 0 ? {
		program: n,
		isParamCanonical: !1
	} : {
		program: i,
		isParamCanonical: !0
	};
}
function eo(e) {
	return `?${new URLSearchParams({ [Xa]: e }).toString()}`;
}
//#endregion
//#region src/lib/hooks/useProgramParam.ts
function to(e) {
	let [t, n] = nt(), { pathname: r } = Ze(), i = Qe(), a = Ce(() => $a(t, e), [t, e]), o = a === null || a.isParamCanonical ? null : a.program.clientId;
	xe(() => {
		o !== null && n((e) => Ya(e, [], { [Xa]: o }), { replace: !0 });
	}, [o, n]);
	let s = ye((e) => {
		i({
			pathname: r,
			search: eo(e)
		});
	}, [i, r]);
	return a === null ? null : {
		program: a.program,
		programSearch: eo(a.program.clientId),
		setClientId: s
	};
}
//#endregion
//#region src/lib/hooks/impersonateQueries.ts
function no(e, { enabled: t }) {
	let n = z();
	return v({
		...H,
		queryKey: V.impersonate(e ?? ""),
		queryFn: ({ signal: e }) => n.getImpersonate(e),
		enabled: t && e !== null
	});
}
//#endregion
//#region src/lib/context/IbImpersonationContext.tsx
var ro = [], io = ve(null);
function ao({ children: e }) {
	let { externalId: t, isEnabled: n, isMocksEnabled: r } = R(), i = n && !r, a = no(t, { enabled: i }), [o, s] = _(null), c = i ? a.data : void 0, l = Ce(() => t === null || c === void 0 || !c.isAllowed ? ro : [.../* @__PURE__ */ new Set([t, ...c.impersonateList])], [t, c]), u = {
		externalId: o !== null && l.includes(o) ? o : t,
		isPending: i && t !== null && a.isPending,
		options: l,
		select: s
	};
	return /* @__PURE__ */ b(io.Provider, {
		value: u,
		children: e
	});
}
function oo() {
	let e = be(io);
	if (e === null) throw Error("useIbImpersonation must be used within IbDeskProvider");
	return e;
}
//#endregion
//#region src/lib/context/IbProgramsContext.tsx
var so = [], co = ve(null);
function lo({ children: e }) {
	let { isEnabled: t } = R(), { externalId: n, isPending: r } = oo(), i = Ja(n, { enabled: t && !r }), a = to(t ? i.data ?? so : so);
	return /* @__PURE__ */ b(co.Provider, {
		value: t ? n === null ? { status: "empty" } : r || i.isPending ? { status: "pending" } : i.isError ? {
			status: "error",
			retry: () => void i.refetch()
		} : a === null ? { status: "empty" } : {
			status: "ready",
			programs: i.data,
			...a
		} : { status: "disabled" },
		children: e
	});
}
function uo() {
	let e = be(co);
	if (e === null) throw Error("useIbProgramsState must be used within IbDeskProvider");
	return e;
}
//#endregion
//#region src/lib/types/constants.ts
var W = "feature-ib";
//#endregion
//#region src/lib/components/shared/Skeleton/Skeleton.tsx
function G({ className: e }) {
	return /* @__PURE__ */ b("div", {
		"aria-hidden": "true",
		className: S("animate-pulse rounded-md bg-backgroundHover", e)
	});
}
//#endregion
//#region src/lib/components/shared/ProgramSelect/ProgramSelectSkeleton.tsx
function fo() {
	return /* @__PURE__ */ b(G, { className: "h-9 w-[268px]" });
}
//#endregion
//#region src/lib/components/shared/ProgramSelect/IbProgramSelect.tsx
var po = 268;
function mo() {
	let { t: e } = g(W), t = uo();
	if (t.status === "pending") return /* @__PURE__ */ b(fo, {});
	if (t.status !== "ready") return null;
	let { programs: n, program: r, setClientId: i } = t, a = n.length === 1;
	return /* @__PURE__ */ b(ae, {
		"aria-label": e("program.label"),
		width: a ? "fit-content" : po,
		style: { maxWidth: po },
		items: n,
		value: r.clientId,
		isReadOnly: a,
		onChange: (e) => {
			e !== null && i(String(e));
		},
		children: (e) => /* @__PURE__ */ b(se, {
			id: e.clientId,
			children: e.name
		})
	});
}
//#endregion
//#region src/lib/hooks/useIbMembership.ts
function ho() {
	let { externalId: e, isAvailable: t, isMocksEnabled: n } = R(), r = Ja(e, { enabled: t }), i = no(e, { enabled: t && !n }), a = (r.data?.length ?? 0) > 0 || i.data?.isAllowed === !0;
	return {
		isIb: a,
		isPending: !a && (r.isLoading || i.isLoading)
	};
}
//#endregion
//#region src/lib/hooks/useIbNavigation.ts
function go(e) {
	let { t } = g(W), { pathname: n } = Ze(), r = uo(), i = r.status === "ready" ? r.programSearch : "", a = [
		{
			id: "overview",
			path: U.overview,
			label: t("navigation.overview")
		},
		{
			id: "clients",
			path: U.clients,
			label: t("navigation.clients")
		},
		{
			id: "subIbs",
			path: U.subIbs,
			label: t("navigation.subIbs")
		},
		{
			id: "rebates",
			path: U.rebates,
			label: t("navigation.rebates")
		}
	].map((t) => ({
		id: t.id,
		label: t.label,
		href: Za(e, t.path, i),
		isCurrent: Ye(`${e}/${t.path}/*`, n) !== null
	}));
	return {
		items: a,
		title: a.find((e) => e.isCurrent)?.label ?? null
	};
}
//#endregion
//#region src/lib/components/impersonate/ImpersonateSelect/ImpersonateSelect.tsx
var _o = 268, vo = "group flex items-center box-border gap-2 px-3 py-1.5 overflow-hidden rounded-md bg-backgroundField text-start text-base/6 text-textPrimary outline transition cursor-pointer forced-colors:bg-[Field]", yo = "outline-1 -outline-offset-1 outline-borderPrimary forced-colors:outline-[ButtonBorder]";
function bo() {
	let { t } = g(W), { externalId: n } = R(), { externalId: r, options: i, select: a } = oo(), { pathname: o } = Ze(), s = Qe(), [c, l] = _(!1), u = Ce(() => i.map((e) => ({
		id: e,
		children: e === n ? t("impersonate.self", { externalId: e }) : e
	})), [
		i,
		n,
		t
	]);
	return r === null || u.length === 0 ? null : /* @__PURE__ */ b("div", {
		className: "mb-4",
		children: /* @__PURE__ */ x(m, {
			isOpen: c,
			onOpenChange: l,
			children: [/* @__PURE__ */ x(ee, {
				"data-open": c || void 0,
				style: {
					width: _o,
					height: me
				},
				className: ({ isFocusVisible: e }) => `${vo} ${e || c ? he : yo}`,
				children: [/* @__PURE__ */ b("span", {
					className: "min-w-0 flex-1 truncate",
					children: t("impersonate.value", { externalId: r })
				}), /* @__PURE__ */ b(at, {
					name: "chevron-down",
					"aria-hidden": !0,
					size: "md",
					className: "shrink-0 text-textSecondary transition-transform group-open:rotate-180 forced-colors:text-[ButtonText]"
				})]
			}), /* @__PURE__ */ b(e, {
				"aria-label": t("impersonate.label"),
				placeholder: t("impersonate.search"),
				className: "min-w-(--trigger-width) max-h-[calc(400px-40px)]",
				items: u,
				selectionMode: "single",
				selectedKeys: [r],
				disallowEmptySelection: !0,
				onAction: (e) => {
					String(e) !== r && (a(String(e)), s({ pathname: o }, { replace: !0 }));
				}
			})]
		})
	});
}
//#endregion
//#region ../../../libs/model-constants/src/constants/defaultLocale.ts
var K = "en-GB", xo = "latn", So = "gregory";
function q() {
	let { i18n: e } = g(W), t = e.language || "en-GB";
	return new Intl.Locale(t, {
		numberingSystem: xo,
		calendar: So
	}).toString();
}
//#endregion
//#region src/lib/components/shared/QueryState/QueryErrorState.tsx
function Co({ onRetry: e }) {
	let { t } = g(W);
	return /* @__PURE__ */ b(ct, {
		align: "center",
		icon: "database-x",
		title: t("states.error.title"),
		description: t("states.error.description"),
		actionLabel: t("states.retry"),
		onAction: e
	});
}
//#endregion
//#region src/lib/context/IbBasePathContext.tsx
var wo = ve(null);
function To({ value: e, children: t }) {
	return /* @__PURE__ */ b(wo.Provider, {
		value: e,
		children: t
	});
}
function Eo() {
	let e = be(wo);
	if (e === null) throw Error("useIbBase must be used within IbDeskLayout");
	return e;
}
//#endregion
//#region src/lib/context/ProgramContext.tsx
var Do = ve(null);
function Oo({ value: e, children: t }) {
	return /* @__PURE__ */ b(Do.Provider, {
		value: e,
		children: t
	});
}
function ko() {
	let e = be(Do);
	if (e === null) throw Error("useCurrentProgram must be used within IbDeskLayout");
	return e;
}
//#endregion
//#region src/lib/hooks/useIbBasePath.ts
function Ao() {
	let { pathname: e } = Ze(), t = et(".").pathname, n = $e()["*"];
	return n === void 0 ? t.replace(/\/+$/, "") : e.slice(0, e.length - n.length).replace(/\/+$/, "");
}
//#endregion
//#region src/lib/layouts/IbDeskLayout/IbDeskLayout.tsx
function jo() {
	let { t: e } = g(W), t = uo();
	return t.status === "disabled" || t.status === "pending" ? null : t.status === "error" ? /* @__PURE__ */ b(Co, { onRetry: t.retry }) : t.status === "empty" ? /* @__PURE__ */ b(ct, {
		align: "center",
		icon: "shapes",
		title: e("program.empty.title"),
		description: e("program.empty.description")
	}) : /* @__PURE__ */ b(Oo, {
		value: t,
		children: /* @__PURE__ */ b(Je, {})
	});
}
function Mo() {
	return /* @__PURE__ */ b(To, {
		value: Ao(),
		children: /* @__PURE__ */ b(jo, {})
	});
}
//#endregion
//#region src/lib/period/period.ts
var No = new Ae(23, 59, 59);
function Po(e) {
	return {
		from: e.from.toString(),
		to: e.to.toString()
	};
}
function Fo(e, t) {
	return {
		from: bt(y(e.from), t),
		to: bt(y(e.to, No), t)
	};
}
var Io = {
	year: 2026,
	month: 1
}, Lo = new ke(Io.year, Io.month, 1), Ro = "en-GB", zo = "mon";
function Bo(e) {
	return {
		year: e.year,
		month: e.month
	};
}
function J(e) {
	return `${e.year}-${String(e.month).padStart(2, "0")}`;
}
function Vo(e, t) {
	let n = new ke(e.year, e.month, 1).add({ months: t });
	return {
		year: n.year,
		month: n.month
	};
}
function Ho(e, t) {
	return e.year === t.year && e.month === t.month;
}
function Uo(e, t) {
	return e.year < t.year || e.year === t.year && e.month < t.month;
}
function Wo(e, t = 12) {
	return Array.from({ length: t }, (t, n) => Vo(e, -n));
}
function Go(e) {
	return Wo(e).filter((e, t) => t === 0 || !Uo(e, Io));
}
function Ko(e) {
	let t = new ke(e.year, e.month, 1);
	return {
		firstDay: t,
		gridStart: ze(t, Ro, zo),
		weekCount: Fe(t, Ro, zo)
	};
}
function qo(e) {
	let t = new ke(e.year, e.month, 1);
	return {
		from: t,
		to: t.add({ days: t.calendar.getDaysInMonth(t) - 1 })
	};
}
function Jo(e, t) {
	let n = qo(e);
	return {
		from: n.from,
		to: n.to.compare(t) > 0 ? t : n.to
	};
}
function Yo(e) {
	return Fo(qo(e), "UTC");
}
function Xo(e) {
	return `${J(e)}-01`;
}
//#endregion
//#region src/lib/period/listPeriod.ts
var Zo = "custom", Qo = "_", $o = /^(\d{4}-\d{2}-\d{2})_(\d{4}-\d{2}-\d{2})$/;
function es(e) {
	return {
		type: "month",
		month: Bo(e)
	};
}
function ts(e, t) {
	return Go(Bo(t)).find((t) => J(t) === e) ?? null;
}
function ns(e, t) {
	let n = $o.exec(e);
	if (n === null) return null;
	let r;
	try {
		r = {
			from: Re(n[1]),
			to: Re(n[2])
		};
	} catch {
		return null;
	}
	let i = r.from.compare(r.to) <= 0, a = r.from.compare(Lo) >= 0 && r.to.compare(t) <= 0;
	return i && a ? r : null;
}
function rs(e, t) {
	if (e === null) return es(t);
	let n = ts(e, t);
	if (n !== null) return {
		type: "month",
		month: n
	};
	let r = ns(e, t);
	return r === null ? es(t) : {
		type: "custom",
		range: r
	};
}
function is(e) {
	return e.type === "month" ? J(e.month) : `${e.range.from.toString()}${Qo}${e.range.to.toString()}`;
}
function as(e, t) {
	return e.type === "month" ? Jo(e.month, t) : e.range;
}
//#endregion
//#region src/lib/period/resolvePeriod.ts
function os(e) {
	return {
		rangeKey: Po(e),
		timeRange: Fo(e, w())
	};
}
function ss(e) {
	let t = os(as(e, T()));
	return e.type === "custom" ? {
		...t,
		compare: "day"
	} : t;
}
function Y(e) {
	return os(Jo(e, T()));
}
//#endregion
//#region src/lib/hooks/keepProgramPlaceholder.ts
function cs(e) {
	return (t, n) => n !== void 0 && Ee({ queryKey: V.client(e ?? "") }, n) ? t : void 0;
}
function ls(e, t) {
	return t && e?.length === 0 ? void 0 : e;
}
//#endregion
//#region src/lib/hooks/dashboardQueries.ts
function us(e) {
	let t = z();
	return v({
		...H,
		queryKey: V.yesterdayRebate(e ?? ""),
		queryFn: ({ signal: n }) => t.getYesterdayRebate(e ?? "", n),
		enabled: e !== void 0
	});
}
function ds(e, t) {
	let n = z(), { rangeKey: r, timeRange: i } = Y(t);
	return v({
		...H,
		queryKey: V.activeClients(e ?? "", r),
		queryFn: ({ signal: t }) => n.getActiveClients(e ?? "", i, t),
		enabled: e !== void 0,
		placeholderData: cs(e)
	});
}
function fs(e, t) {
	let n = z(), { rangeKey: r, timeRange: i } = Y(t);
	return v({
		...H,
		queryKey: V.netDeposits(e ?? "", r),
		queryFn: ({ signal: t }) => n.getNetDeposits(e ?? "", i, t),
		enabled: e !== void 0,
		placeholderData: cs(e)
	});
}
function ps(e) {
	let t = z(), n = Bo(vt()), r = Yo(n);
	return v({
		...H,
		queryKey: V.switchBonus(e ?? "", J(n)),
		queryFn: ({ signal: n }) => t.getSwitchBonus(e ?? "", r, n),
		enabled: e !== void 0
	});
}
function ms(e, t, n, r) {
	let i = z(), { rangeKey: a, timeRange: o } = Y(t);
	return v({
		...H,
		queryKey: V.leaderboard(e ?? "", a, n, r),
		queryFn: ({ signal: t }) => i.getLeaderboard(e ?? "", {
			type: n,
			sortBy: r,
			...o
		}, t),
		enabled: e !== void 0,
		placeholderData: cs(e)
	});
}
function hs(e, t, n) {
	let r = z(), { rangeKey: i, timeRange: a } = Y(t);
	return v({
		...H,
		queryKey: V.topSubIbs(e ?? "", i, n),
		queryFn: ({ signal: t }) => r.getTopSubIbs(e ?? "", {
			type: n,
			...a
		}, t),
		enabled: e !== void 0,
		placeholderData: cs(e)
	});
}
//#endregion
//#region src/lib/components/clients/StatusBadge/StatusBadge.tsx
var gs = {
	active: "success",
	lowActivity: "warning",
	inactive: "neutral"
};
function _s({ status: e }) {
	let { t } = g(W);
	return /* @__PURE__ */ b(n, {
		size: "sm",
		variant: gs[e],
		children: t(`status.${e}`)
	});
}
//#endregion
//#region src/lib/components/dashboard/ScopeToggle/ScopeToggle.tsx
function vs({ onChange: e, value: t }) {
	let { t: n } = g(W);
	function r(t) {
		let n = _i.find((e) => e === t);
		n !== void 0 && e(n);
	}
	return /* @__PURE__ */ b(fe, {
		"aria-label": n("widgets.scope.label"),
		className: "self-start auto-cols-auto",
		selectedKey: t,
		onSelectionChange: r,
		children: _i.map((e) => /* @__PURE__ */ b(de, {
			id: e,
			children: n(`widgets.scope.${e}`)
		}, e))
	});
}
//#endregion
//#region src/lib/components/dashboard/ViewAllLink/ViewAllLink.tsx
function ys({ href: e }) {
	let { t } = g(W);
	return /* @__PURE__ */ x(u, {
		variant: "subtle",
		href: e,
		className: "text-base font-medium",
		children: [t("widgets.viewAll"), /* @__PURE__ */ b(at, {
			name: "chevron-right",
			size: "sm",
			className: "rtl:-scale-x-100"
		})]
	});
}
//#endregion
//#region src/lib/components/shared/Skeleton/SkeletonLine.tsx
function X({ lineClassName: e, className: t }) {
	return /* @__PURE__ */ b("div", {
		"aria-hidden": "true",
		className: S("flex flex-col justify-center", e),
		children: /* @__PURE__ */ b(G, { className: S("rounded-sm", t) })
	});
}
//#endregion
//#region src/lib/components/dashboard/ClientsLeaderboard/ClientsLeaderboardSkeleton.tsx
var bs = [
	"w-18.5",
	"w-22.5",
	"w-26",
	"w-30",
	"w-33.5"
], xs = 4;
function Ss() {
	return /* @__PURE__ */ b(le, { children: bs.map((e, t) => /* @__PURE__ */ x(ie, {
		id: t,
		children: [/* @__PURE__ */ b(i, { children: /* @__PURE__ */ b(X, {
			lineClassName: "h-5",
			className: S("h-2.5", e)
		}) }), Array.from({ length: xs }, (e, t) => /* @__PURE__ */ b(i, {
			align: "end",
			children: /* @__PURE__ */ b(X, {
				lineClassName: "h-5",
				className: "h-2.5"
			})
		}, t))]
	}, t)) });
}
//#endregion
//#region src/lib/utils/formatters.ts
var Cs = "USD", ws = "US$", Ts = "$", Es = "UTC", Ds = "gregory", Os = 2, ks = 2, As = 1, js = 0, Ms = 1, Ns = "en";
function Ps(e, t) {
	return Number(e.toFixed(t, Ge.HalfUp));
}
function Fs(e, t, n) {
	return dt(Ps(e, t), n, {
		minimumFractionDigits: t,
		maximumFractionDigits: t
	});
}
function Is(e, t, n) {
	return ut(e, Cs, t, n).replace(ws, Ts);
}
function Ls(e, t) {
	return dt(Ps(e, As) / 100, t, {
		style: "percent",
		minimumFractionDigits: As,
		maximumFractionDigits: As
	});
}
function Rs(e, t = K) {
	return dt(Ps(e, js) / 100, t, {
		style: "percent",
		minimumFractionDigits: js,
		maximumFractionDigits: js
	});
}
function Z(e, t = K, { decimals: n = Os, minDecimals: r = n } = {}) {
	return Is(Ps(e, n), t, {
		minimumFractionDigits: r,
		maximumFractionDigits: n
	});
}
function zs(e, t = K) {
	return Is(e, t, {
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	});
}
function Bs(e, t, n) {
	let r = new Intl.Locale(t.resolvedOptions().locale).language === Ns;
	return t.formatToParts(e).map((e) => !r || e.type !== "compact" ? e.value : n === "upper" ? e.value.toUpperCase() : e.value.toLowerCase()).join("");
}
function Vs(e, t = K) {
	return Bs(e, lt(Cs, t, {
		notation: "compact",
		minimumFractionDigits: 0,
		maximumFractionDigits: Ms
	}), "lower").replace(ws, Ts);
}
function Hs(e, t = K) {
	return Bs(e, new Intl.NumberFormat(t, {
		notation: "compact",
		maximumFractionDigits: Ms
	}), "upper");
}
function Us(e, t = K) {
	return Fs(e, ks, t);
}
function Q(e, t = K) {
	return dt(e, t, { maximumFractionDigits: 0 });
}
function Ws(e, t = K) {
	return e.unit === "count" ? Q(Ps(e.value, 0), t) : Ls(e.value, t);
}
function Gs(e, t, n) {
	return new Intl.DateTimeFormat(t, {
		...n,
		calendar: Ds,
		timeZone: Es
	}).format(e.toDate(Es));
}
function Ks(e, t, n) {
	let r = new Date(Date.UTC(e.year, e.month - 1, 1));
	return new Intl.DateTimeFormat(t, {
		...n,
		calendar: Ds,
		timeZone: Es
	}).format(r);
}
function qs(e, t = K) {
	return Gs(e, t, {
		day: "numeric",
		month: "short",
		year: "numeric"
	});
}
function Js(e, t = K) {
	return new Intl.DateTimeFormat(t, {
		day: "numeric",
		month: "short",
		year: "numeric",
		calendar: Ds,
		timeZone: Es
	}).formatRange(e.from.toDate(Es), e.to.toDate(Es));
}
function Ys(e, t, n) {
	return new Intl.DateTimeFormat(t, {
		...n,
		calendar: Ds,
		timeZone: w()
	}).format(e);
}
function Xs(e, t = K) {
	return Ys(e, t, {
		day: "numeric",
		month: "short",
		year: "numeric"
	});
}
function Zs(e, t = K) {
	return Ys(e, t, {
		hour: "2-digit",
		minute: "2-digit"
	});
}
function Qs(e, t = K) {
	return Gs(e, t, { dateStyle: "long" });
}
function $s(e, t = K) {
	return Gs(e, t, { weekday: "narrow" });
}
function ec(e, t = K) {
	return Gs(e, t, {
		weekday: "short",
		day: "numeric",
		month: "short"
	});
}
function tc(e, t, n = K) {
	let r = {
		day: "numeric",
		month: "short"
	};
	return e.year === t ? Gs(e, n, r) : Gs(e, n, {
		...r,
		year: "numeric"
	});
}
function nc(e, t = K) {
	return Gs(e, t, {
		day: "numeric",
		month: "short"
	});
}
function rc(e, t = K) {
	return Ks(e, t, {
		month: "long",
		year: "numeric"
	});
}
function ic(e, t = K) {
	return Ks(e, t, { month: "long" });
}
function ac(e, t = K) {
	return Ks(e, t, { month: "short" });
}
//#endregion
//#region src/lib/components/dashboard/ClientsLeaderboard/utils/buildLeaderboardRows.ts
var oc = "—", sc = "0.005";
function cc(e) {
	return e.abs().lessThan(sc);
}
function lc(e, t) {
	return {
		text: Z(e, t),
		isMuted: cc(e)
	};
}
function uc(e, t) {
	return cc(e) ? {
		text: oc,
		isMuted: !0
	} : {
		text: Z(e, t),
		isMuted: !1
	};
}
function dc(e, t) {
	let n = cc(e);
	return {
		text: Z(e.abs(), t),
		isMuted: n,
		isNegative: !n && e.isNegative()
	};
}
function fc(e, t, n) {
	return e === null ? {
		text: oc,
		isMuted: !0
	} : {
		text: tc(e, t, n),
		isMuted: !1
	};
}
function pc(e, t, n) {
	return e.map((e) => ({
		rowKey: e.rowKey,
		name: It(e.name, e.email),
		isLowActivity: e.status === "lowActivity",
		rewards: lc(e.rewards, t),
		balance: uc(e.balance, t),
		netDeposits: dc(e.netDeposits, t),
		lastTradeAt: fc(e.lastTradeAt, n.year, t)
	}));
}
function mc(e) {
	return vi.find((t) => t === e) ?? null;
}
//#endregion
//#region src/lib/components/dashboard/ClientsLeaderboard/ClientsLeaderboardWidget.tsx
var hc = "direct", gc = "rebate", _c = "-mx-4 w-auto", vc = {
	rebate: 120,
	balance: 124,
	netDeposits: 140,
	lastTrade: 120
}, yc = 2, bc = 200;
function xc({ className: e, clientId: t, month: n }) {
	let { t: o } = g(W), s = q(), c = Eo(), { programSearch: l } = ko(), [u, d] = _(hc), [f, p] = _(gc), m = ms(t, n, u, f), ee = o("widgets.titles.clientsLeaderboard"), h = Qa(l, { [Pt]: J(n) });
	function te() {
		m.refetch();
	}
	function ne({ column: e }) {
		let t = mc(e);
		t !== null && p(t);
	}
	function re(e) {
		return e.isNegative ? /* @__PURE__ */ b(st, {
			variant: "semantic",
			marker: "sign",
			trend: "negative",
			value: e.text
		}) : e.text;
	}
	function ae() {
		return /* @__PURE__ */ b("div", {
			className: "py-8",
			children: /* @__PURE__ */ b(ct, {
				align: "center",
				icon: "shapes",
				title: o("widgets.leaderboard.empty.title"),
				description: o(`widgets.leaderboard.empty.descriptions.${u}`)
			})
		});
	}
	function oe(e, t) {
		let n = e === void 0, r = n || e.length > 0;
		return /* @__PURE__ */ b("div", {
			"aria-busy": n || t,
			className: S("flex min-w-0 flex-col transition-opacity", t && "opacity-60"),
			children: /* @__PURE__ */ x(ce, {
				"aria-label": ee,
				variant: "plain",
				className: _c,
				sortDescriptor: r ? {
					column: f,
					direction: "descending"
				} : void 0,
				onSortChange: ne,
				children: [/* @__PURE__ */ x(ue, {
					variant: "plain",
					children: [
						/* @__PURE__ */ b(a, {
							id: "client",
							isRowHeader: !0,
							minWidth: bc,
							maxLines: yc,
							children: o("widgets.leaderboard.columns.client")
						}),
						/* @__PURE__ */ b(a, {
							id: "rebate",
							align: "end",
							width: vc.rebate,
							allowsSorting: r,
							maxLines: yc,
							children: o("widgets.leaderboard.columns.rebate")
						}),
						/* @__PURE__ */ b(a, {
							id: "balance",
							align: "end",
							width: vc.balance,
							allowsSorting: r,
							maxLines: yc,
							children: o("widgets.leaderboard.columns.balance")
						}),
						/* @__PURE__ */ b(a, {
							id: "netDeposits",
							align: "end",
							width: vc.netDeposits,
							allowsSorting: r,
							maxLines: yc,
							children: o("widgets.leaderboard.columns.netDeposits")
						}),
						/* @__PURE__ */ b(a, {
							id: "lastTrade",
							align: "end",
							width: vc.lastTrade,
							maxLines: yc,
							children: o("widgets.leaderboard.columns.lastTrade")
						})
					]
				}), n ? /* @__PURE__ */ b(Ss, {}) : /* @__PURE__ */ b(le, {
					items: e,
					renderEmptyState: ae,
					children: (e) => /* @__PURE__ */ x(ie, {
						id: e.rowKey,
						children: [
							/* @__PURE__ */ b(i, { children: /* @__PURE__ */ x("div", {
								className: "flex min-w-0 items-center gap-2",
								children: [/* @__PURE__ */ b(C, {
									text: e.name,
									className: "uppercase"
								}), e.isLowActivity && /* @__PURE__ */ b("span", {
									className: "shrink-0",
									children: /* @__PURE__ */ b(_s, { status: "lowActivity" })
								})]
							}) }),
							/* @__PURE__ */ b(i, {
								align: "end",
								isMuted: e.rewards.isMuted,
								children: e.rewards.text
							}),
							/* @__PURE__ */ b(i, {
								align: "end",
								isMuted: e.balance.isMuted,
								children: e.balance.text
							}),
							/* @__PURE__ */ b(i, {
								align: "end",
								isMuted: e.netDeposits.isMuted,
								children: re(e.netDeposits)
							}),
							/* @__PURE__ */ b(i, {
								align: "end",
								isMuted: e.lastTradeAt.isMuted,
								children: e.lastTradeAt.text
							})
						]
					})
				})]
			})
		});
	}
	function se() {
		let { data: e, isError: t, isPlaceholderData: n } = m, r = ls(e, n);
		return r === void 0 ? t ? /* @__PURE__ */ b(Co, { onRetry: te }) : oe(void 0, !1) : oe(pc(r, s, T()), n);
	}
	return /* @__PURE__ */ b(r, {
		title: ee,
		action: /* @__PURE__ */ b(ys, { href: Za(c, U.clients, h) }),
		className: e,
		children: /* @__PURE__ */ x("div", {
			className: "flex flex-col gap-2",
			children: [/* @__PURE__ */ b(vs, {
				value: u,
				onChange: d
			}), se()]
		})
	});
}
//#endregion
//#region src/lib/hooks/calendarQueries.ts
function Sc(e, t) {
	let n = z(), r = J(t);
	return v({
		...H,
		queryKey: V.calendar(e ?? "", r),
		queryFn: ({ signal: r }) => n.getCalendar(e ?? "", Yo(t), r),
		enabled: e !== void 0
	});
}
function Cc(e, t) {
	let n = z(), r = J(t);
	return v({
		...H,
		queryKey: V.monthSummary(e ?? "", r),
		queryFn: ({ signal: r }) => n.getMonthSummary(e ?? "", Xo(t), r),
		enabled: e !== void 0,
		placeholderData: cs(e)
	});
}
//#endregion
//#region src/lib/components/dashboard/CommissionsCalendar/components/CalendarDayCell.tsx
var wc = "—", Tc = "\xA0", Ec = {
	noRebate: "text-textSecondary opacity-50",
	rebate: "text-textPrimary",
	upcoming: "invisible"
}, Dc = "flex flex-col justify-center gap-2 rounded-md px-2 py-1 @max-md:aspect-square @max-md:gap-0 @max-md:p-1.5", Oc = "text-sm text-textSecondary tabular-nums @max-md:text-xs";
function kc(e) {
	return e.kind === "rebate" ? e.amount : e.kind === "noRebate" ? wc : Tc;
}
function Ac({ cell: e }) {
	if (e.kind === "outside") return /* @__PURE__ */ b("li", { "aria-hidden": "true" });
	if (e.kind === "pending") return /* @__PURE__ */ x("li", {
		className: Dc,
		children: [
			/* @__PURE__ */ b("span", {
				className: "sr-only",
				children: e.ariaLabel
			}),
			/* @__PURE__ */ b("span", {
				"aria-hidden": "true",
				className: Oc,
				children: e.dayNumber
			}),
			/* @__PURE__ */ b(X, {
				lineClassName: "h-6 @max-md:h-4",
				className: "h-[11px] w-10.5 max-w-full"
			})
		]
	});
	let t = e.kind !== "upcoming";
	return /* @__PURE__ */ x("li", {
		className: S(Dc, t && "transition-colors hover:bg-backgroundHover"),
		children: [
			/* @__PURE__ */ b("span", {
				className: "sr-only",
				children: e.ariaLabel
			}),
			/* @__PURE__ */ b("span", {
				"aria-hidden": "true",
				className: S(Oc, !t && "opacity-30"),
				children: e.dayNumber
			}),
			/* @__PURE__ */ b("span", {
				"aria-hidden": "true",
				className: S("truncate text-lg font-medium tabular-nums @max-md:text-xs", Ec[e.kind]),
				children: kc(e)
			})
		]
	});
}
//#endregion
//#region src/lib/components/dashboard/CommissionsCalendar/utils/buildCalendarView.ts
var jc = 7, Mc = We.from(0);
function Nc(e, t) {
	return Z(e, t, { decimals: e.abs().lessThan(1) ? 2 : 0 });
}
function Pc(e, t, n, r) {
	let i = e.toString(), a = Qs(e, n);
	return e.compare(r) >= 0 ? {
		kind: "upcoming",
		key: i,
		dayNumber: e.day,
		ariaLabel: a
	} : t === void 0 || t.isZero() ? {
		kind: "noRebate",
		key: i,
		dayNumber: e.day,
		ariaLabel: `${a}, ${Z(Mc, n)}`
	} : {
		kind: "rebate",
		key: i,
		dayNumber: e.day,
		ariaLabel: `${a}, ${Z(t, n)}`,
		amount: Nc(t, n)
	};
}
function Fc({ days: e, locale: t, month: n, today: r }) {
	let { firstDay: i, gridStart: a, weekCount: o } = Ko(n), s = new Map((e ?? []).map((e) => [e.date.toString(), e.value]));
	return {
		weekdays: Array.from({ length: jc }, (e, n) => $s(a.add({ days: n }), t)),
		cells: Array.from({ length: o * jc }, (n, o) => {
			let c = a.add({ days: o });
			return Ie(c, i) ? e === null && c.compare(r) < 0 ? {
				kind: "pending",
				key: c.toString(),
				dayNumber: c.day,
				ariaLabel: Qs(c, t)
			} : Pc(c, s.get(c.toString()), t, r) : {
				kind: "outside",
				key: c.toString()
			};
		})
	};
}
//#endregion
//#region src/lib/components/dashboard/CommissionsCalendar/CommissionsCalendar.tsx
function Ic({ clientId: e, month: t }) {
	let { t: n } = g(W), r = q(), i = Sc(e, t), { data: a, isError: o } = i;
	function s() {
		i.refetch();
	}
	if (a === void 0 && o) return /* @__PURE__ */ b(Co, { onRetry: s });
	let c = Fc({
		month: t,
		days: a ?? null,
		locale: r,
		today: T()
	});
	return /* @__PURE__ */ x("div", {
		className: "@container flex flex-1 flex-col gap-2 pt-1",
		children: [/* @__PURE__ */ b("div", {
			"aria-hidden": "true",
			className: "grid grid-cols-7 gap-2 pb-2 @max-md:gap-1",
			children: c.weekdays.map((e, t) => /* @__PURE__ */ b("span", {
				className: "truncate ps-2 text-sm text-textSecondary @max-md:ps-1.5 @max-md:text-xs",
				children: e
			}, t))
		}), /* @__PURE__ */ b("ol", {
			"aria-busy": a === void 0 || void 0,
			"aria-label": n("widgets.calendar.gridLabel"),
			className: "grid flex-1 auto-rows-fr grid-cols-7 gap-2 @max-md:gap-1",
			children: c.cells.map((e) => /* @__PURE__ */ b(Ac, { cell: e }, e.key))
		})]
	});
}
//#endregion
//#region src/lib/utils/initials.ts
var Lc = 2;
function Rc(e) {
	let t = e.trim().split(/\s+/).slice(0, Lc).map((e) => e.charAt(0)).join("").toUpperCase();
	return t === "" ? void 0 : t;
}
//#endregion
//#region src/lib/components/dashboard/Highlights/components/BestDayLeaf.tsx
var zc = "—";
function Bc({ date: e, locale: t, month: n }) {
	return /* @__PURE__ */ x("div", {
		className: "flex w-10 flex-col overflow-hidden rounded-md border border-borderSurface text-center",
		children: [/* @__PURE__ */ b("span", {
			className: S("bg-brandPrimary py-px text-sm font-medium whitespace-nowrap text-textOnBrandPrimary uppercase", e === null && "opacity-35"),
			children: ac(n, t)
		}), /* @__PURE__ */ b("span", {
			className: S("pt-px pb-0.5 text-base font-medium text-textPrimary tabular-nums", e === null && "opacity-50"),
			children: e === null ? zc : Q(e.day, t)
		})]
	});
}
//#endregion
//#region src/lib/components/dashboard/Highlights/components/HighlightTile.tsx
var Vc = "—", Hc = [
	"border-e border-b",
	"border-b",
	"border-e",
	""
];
function Uc({ className: e, isValueUppercase: t = !1, label: n, value: r, visual: i, visualLabel: a }) {
	return /* @__PURE__ */ x("div", {
		className: S("flex min-w-0 flex-col gap-0.5 border-borderSurface p-4", e),
		children: [/* @__PURE__ */ b("dt", {
			className: "order-last text-base text-textSecondary",
			children: n
		}), /* @__PURE__ */ x("dd", {
			className: "flex min-w-0 flex-1 flex-col justify-between gap-9",
			children: [/* @__PURE__ */ b("div", {
				"aria-hidden": !0,
				className: "flex min-h-10",
				children: i
			}), /* @__PURE__ */ x("span", {
				className: "flex min-w-0 text-xl/6 font-semibold text-textPrimary tabular-nums",
				children: [r === null ? /* @__PURE__ */ b("span", {
					className: "opacity-50",
					children: Vc
				}) : /* @__PURE__ */ b(C, {
					text: r,
					className: S(t && "uppercase")
				}), a !== void 0 && /* @__PURE__ */ b("span", {
					className: "sr-only",
					children: a
				})]
			})]
		})]
	});
}
//#endregion
//#region src/lib/components/dashboard/Highlights/components/WeeklyRebateBars.tsx
function Wc({ bars: e }) {
	return /* @__PURE__ */ b("div", {
		className: "flex h-10 items-end gap-0.5",
		children: e.map((e) => e.kind === "filled" ? /* @__PURE__ */ b("span", {
			className: "block min-h-0.75 w-2.25 rounded-xs bg-brandPrimary",
			style: { height: `${e.ratio * 100}%` }
		}, e.key) : /* @__PURE__ */ b("span", { className: "block h-0.75 w-2.25 rounded-xs bg-brandPrimarySubtle" }, e.key))
	});
}
//#endregion
//#region src/lib/components/dashboard/Highlights/HighlightsSkeleton.tsx
var Gc = [
	{
		labelKey: "widgets.highlights.monthRebate",
		visualClassName: "h-10 w-[53px] rounded-lg"
	},
	{
		labelKey: "widgets.highlights.bestDay",
		visualClassName: "h-[43px] w-10 rounded-lg"
	},
	{
		labelKey: "widgets.highlights.topPair",
		visualClassName: "size-10 rounded-full"
	},
	{
		labelKey: "widgets.highlights.topClient",
		visualClassName: "size-10 rounded-full"
	}
];
function Kc() {
	let { t: e } = g(W);
	return /* @__PURE__ */ b("dl", {
		"aria-busy": "true",
		className: "grid grid-cols-2",
		children: Gc.map(({ labelKey: t, visualClassName: n }, r) => /* @__PURE__ */ x("div", {
			className: S("flex min-w-0 flex-col gap-0.5 border-borderSurface p-4", Hc[r]),
			children: [/* @__PURE__ */ b("dt", {
				className: "order-last text-base text-textSecondary",
				children: e(t)
			}), /* @__PURE__ */ x("dd", {
				className: "flex min-w-0 flex-1 flex-col justify-between gap-9",
				children: [/* @__PURE__ */ b("div", {
					className: "flex min-h-10",
					children: /* @__PURE__ */ b(G, { className: n })
				}), /* @__PURE__ */ b(X, {
					lineClassName: "h-6",
					className: "h-[13px]"
				})]
			})]
		}, t))
	});
}
//#endregion
//#region src/lib/components/dashboard/Highlights/utils/buildWeeklyRebateBars.ts
var qc = 7;
function Jc(e, t) {
	return e.compare(t) <= 0 ? e : t;
}
function Yc(e, t, n) {
	return e.filter((e) => e.date.compare(t) >= 0 && e.date.compare(n) <= 0).reduce((e, t) => e.plus(t.value), We.from(0));
}
function Xc(e, t, n) {
	let { firstDay: r, gridStart: i, weekCount: a } = Ko(t), o = r.add({ days: r.calendar.getDaysInMonth(r) - 1 }), s = e.filter((e) => Ie(e.date, r));
	return Array.from({ length: a }, (e, t) => {
		let r = i.add({ weeks: t }), a = Jc(r.add({ days: qc - 1 }), o);
		return {
			key: r.toString(),
			isOver: a.compare(n) < 0,
			total: Yc(s, r, a)
		};
	});
}
function Zc(e) {
	return e.isOver && e.total.isPositive();
}
function Qc({ days: e, month: t, today: n }) {
	let r = Xc(e ?? [], t, n), i = r.filter(Zc).map((e) => e.total);
	if (i.length === 0) return r.map((e) => ({
		key: e.key,
		kind: "stub"
	}));
	let [a, ...o] = i, s = We.max(a, ...o);
	return r.map((e) => Zc(e) ? {
		key: e.key,
		kind: "filled",
		ratio: e.total.divide(s).toNumber()
	} : {
		key: e.key,
		kind: "stub"
	});
}
//#endregion
//#region src/lib/components/dashboard/Highlights/HighlightsWidget.tsx
var $c = 40;
function el({ className: e, clientId: n, month: i }) {
	let { t: a } = g(W), o = q(), { symbolIconsBaseUrl: s } = R(), c = Cc(n, i), l = Sc(n, i);
	function u() {
		c.refetch();
	}
	function d(e) {
		let { bestDayAmount: n, bestDayDate: r, topClientName: u, topPair: d, totalCommissionAmount: f } = e, p = Qc({
			days: c.isPlaceholderData ? void 0 : l.data,
			month: i,
			today: T()
		});
		return [
			{
				id: "monthRebate",
				label: a("widgets.highlights.monthRebate"),
				value: Z(f, o),
				visual: /* @__PURE__ */ b(Wc, { bars: p })
			},
			{
				id: "bestDay",
				label: a("widgets.highlights.bestDay"),
				value: r === null ? null : Z(n, o),
				visual: /* @__PURE__ */ b(Bc, {
					date: r,
					month: i,
					locale: o
				}),
				visualLabel: r === null ? void 0 : Qs(r, o)
			},
			{
				id: "topPair",
				label: a("widgets.highlights.topPair"),
				value: d,
				visual: d !== null && /* @__PURE__ */ b(ft, {
					symbol: d,
					size: $c,
					logoUrls: pt(s, d, { preferPair: !0 })
				})
			},
			{
				id: "topClient",
				label: a("widgets.highlights.topClient"),
				value: u,
				isValueUppercase: !0,
				visual: u !== null && /* @__PURE__ */ b(t, {
					size: "md",
					variant: "brandSolid",
					initials: Rc(u)
				})
			}
		];
	}
	function f() {
		let { data: e, isError: t, isPlaceholderData: n } = c;
		return e === void 0 ? t ? /* @__PURE__ */ b(Co, { onRetry: u }) : /* @__PURE__ */ b(Kc, {}) : /* @__PURE__ */ b("dl", {
			"aria-busy": n,
			className: S("grid grid-cols-2 transition-opacity", n && "opacity-60"),
			children: d(e).map((e, t) => /* @__PURE__ */ b(Uc, {
				label: e.label,
				value: e.value,
				isValueUppercase: e.isValueUppercase,
				visual: e.visual,
				visualLabel: e.visualLabel,
				className: Hc[t]
			}, e.id))
		});
	}
	return /* @__PURE__ */ b(r, {
		title: a("widgets.titles.highlights", { month: ic(i, o) }),
		className: e,
		children: f()
	});
}
//#endregion
//#region src/lib/components/dashboard/KpiCard/KpiCardHeader.tsx
function tl({ label: e, hint: t }) {
	let { t: n } = g(W);
	return /* @__PURE__ */ x("div", {
		className: "flex items-center justify-between gap-2",
		children: [/* @__PURE__ */ b("span", {
			className: "text-base font-medium text-textPrimary",
			children: e
		}), t !== void 0 && /* @__PURE__ */ b(l, {
			name: "info",
			size: "sm",
			variant: "plain",
			className: "-m-1 text-textSecondary",
			"aria-label": n("kpi.hints.label"),
			tooltip: t
		})]
	});
}
//#endregion
//#region src/lib/components/dashboard/KpiCard/KpiCard.tsx
var nl = "text-3xl font-semibold text-textPrimary tabular-nums";
function rl({ value: e, label: t, caption: n, delta: i, hint: a, isRefreshing: o = !1, isValueTruncated: s = !1, unit: c, valueIcon: l }) {
	function u() {
		return s ? /* @__PURE__ */ b(C, {
			text: e,
			className: S(nl, "min-w-0")
		}) : /* @__PURE__ */ b("span", {
			className: nl,
			children: e
		});
	}
	function d() {
		return l === void 0 ? u() : /* @__PURE__ */ x("span", {
			className: "flex min-w-0 max-w-full items-center gap-1.5",
			children: [l, u()]
		});
	}
	return /* @__PURE__ */ b(r, { children: /* @__PURE__ */ x("div", {
		className: "flex flex-col gap-2",
		children: [/* @__PURE__ */ b(tl, {
			label: t,
			hint: a
		}), /* @__PURE__ */ x("div", {
			"aria-busy": o || void 0,
			className: S("flex flex-col gap-2 transition-opacity", o && "opacity-60"),
			children: [/* @__PURE__ */ x("div", {
				className: "flex flex-wrap items-baseline gap-2",
				children: [c === void 0 ? d() : /* @__PURE__ */ x("span", {
					className: "flex items-baseline gap-1.5",
					children: [d(), /* @__PURE__ */ b("span", {
						className: "text-lg text-textSecondary",
						children: c
					})]
				}), i !== void 0 && /* @__PURE__ */ b(st, {
					variant: "semantic",
					size: "sm",
					marker: "arrow",
					value: i.value,
					trend: i.trend
				})]
			}), n !== void 0 && /* @__PURE__ */ b("span", {
				className: "text-base text-textSecondary",
				children: n
			})]
		})]
	}) });
}
//#endregion
//#region src/lib/components/dashboard/KpiCard/KpiCardError.tsx
function il({ label: e, onRetry: t }) {
	let { t: n } = g(W);
	return /* @__PURE__ */ b(r, { children: /* @__PURE__ */ x("div", {
		className: "flex flex-col gap-2",
		children: [
			/* @__PURE__ */ b("span", {
				className: "text-base font-medium text-textPrimary",
				children: e
			}),
			/* @__PURE__ */ x("div", {
				className: "flex items-center gap-2 py-1 text-textSecondary",
				children: [/* @__PURE__ */ b(at, {
					name: "database-x",
					size: "sm",
					"aria-hidden": !0
				}), /* @__PURE__ */ b("span", {
					className: "text-sm font-medium",
					children: n("states.error.short")
				})]
			}),
			/* @__PURE__ */ b(h, {
				className: "self-start",
				onPress: t,
				children: n("states.retry")
			})
		]
	}) });
}
//#endregion
//#region src/lib/components/dashboard/KpiCard/KpiCardSkeleton.tsx
var al = {
	value: "w-32",
	delta: null
};
function ol({ label: e, hint: t, widths: n = al }) {
	let { value: i, delta: a } = n;
	return /* @__PURE__ */ b(r, { children: /* @__PURE__ */ x("div", {
		className: "flex flex-col gap-2",
		children: [/* @__PURE__ */ b(tl, {
			label: e,
			hint: t
		}), /* @__PURE__ */ x("div", {
			"aria-busy": "true",
			className: "flex flex-col gap-2",
			children: [/* @__PURE__ */ x("div", {
				className: "flex items-end gap-1.5",
				children: [/* @__PURE__ */ b(X, {
					lineClassName: "h-8",
					className: S("h-[17px]", i)
				}), a !== null && /* @__PURE__ */ b(X, {
					lineClassName: "h-6",
					className: S("h-[11px]", a)
				})]
			}), /* @__PURE__ */ b(X, {
				lineClassName: "h-5",
				className: "h-2.5"
			})]
		})]
	}) });
}
//#endregion
//#region src/lib/components/dashboard/KpiCard/KpiQueryCard.tsx
function sl({ hint: e, label: t, query: n, skeletonWidths: r, toView: i }) {
	let { data: a, isError: o, isPlaceholderData: s } = n;
	function c() {
		n.refetch();
	}
	return a === void 0 ? o ? /* @__PURE__ */ b(il, {
		label: t,
		onRetry: c
	}) : /* @__PURE__ */ b(ol, {
		label: t,
		hint: e,
		widths: r
	}) : /* @__PURE__ */ b(rl, {
		label: t,
		hint: e,
		isRefreshing: s,
		...i(a)
	});
}
//#endregion
//#region src/lib/components/dashboard/KpiRow/utils/buildKpiView.ts
var cl = { decimals: 0 }, ll = " · ";
function ul(e, t) {
	if (e !== null) return {
		value: Ws(e, t),
		trend: e.trend
	};
}
function dl(e) {
	return {
		yesterdayRebate: e("kpi.yesterdayRebate"),
		activeClients: e("kpi.activeClients"),
		netDeposits: e("kpi.netDeposits")
	};
}
function fl(e) {
	return {
		yesterdayRebate: e("kpi.hints.yesterdayRebate"),
		activeClients: e("kpi.hints.activeClients"),
		netDeposits: e("kpi.hints.netDeposits")
	};
}
function pl({ amount: e, date: t }, { locale: n, t: r }) {
	return {
		value: Z(e, n),
		caption: t === null ? r("kpi.captions.noBatch") : ec(t, n)
	};
}
function ml({ active: e, delta: t, lowActivity: n, networkTotal: r }, { locale: i, t: a }) {
	let o = [];
	return r > 0 && o.push(a("kpi.captions.ofClients", {
		count: r,
		total: Q(r, i)
	})), o.push(a("kpi.captions.lowActivity", {
		count: n,
		value: Q(n, i)
	})), {
		value: Q(e, i),
		delta: ul(t, i),
		caption: o.join(ll)
	};
}
function hl({ delta: e, in: t, net: n, out: r }, { locale: i, t: a }) {
	return {
		value: Z(n, i, cl),
		delta: ul(e, i),
		caption: a("kpi.captions.depositsWithdrawals", {
			deposits: Z(t, i, cl),
			withdrawals: Z(r, i, cl)
		})
	};
}
//#endregion
//#region src/lib/components/dashboard/KpiRow/KpiRow.tsx
var gl = {
	yesterdayRebate: {
		value: "w-32",
		delta: null
	},
	activeClients: {
		value: "w-15",
		delta: "w-14"
	},
	netDeposits: {
		value: "w-32",
		delta: "w-14"
	}
};
function _l({ clientId: e, month: t }) {
	let { t: n } = g(W), r = {
		locale: q(),
		t: n
	}, i = dl(n), a = fl(n), o = us(e), s = ds(e, t), c = fs(e, t);
	return /* @__PURE__ */ x("div", {
		className: "grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3",
		children: [
			/* @__PURE__ */ b(sl, {
				label: i.yesterdayRebate,
				hint: a.yesterdayRebate,
				skeletonWidths: gl.yesterdayRebate,
				query: o,
				toView: (e) => pl(e, r)
			}),
			/* @__PURE__ */ b(sl, {
				label: i.activeClients,
				hint: a.activeClients,
				skeletonWidths: gl.activeClients,
				query: s,
				toView: (e) => ml(e, r)
			}),
			/* @__PURE__ */ b(sl, {
				label: i.netDeposits,
				hint: a.netDeposits,
				skeletonWidths: gl.netDeposits,
				query: c,
				toView: (e) => hl(e, r)
			})
		]
	});
}
//#endregion
//#region src/lib/components/dashboard/MonthStepper/components/MonthSelect.tsx
function vl({ month: e, months: t, onChange: n }) {
	let { t: r } = g(W), i = q(), a = Ce(() => t.map((e) => ({
		id: J(e),
		label: rc(e, i),
		month: e
	})), [t, i]);
	return /* @__PURE__ */ b(oe, {
		size: "lg",
		"aria-label": r("month.label"),
		value: J(e),
		onChange: (e) => {
			let t = a.find((t) => t.id === e);
			t !== void 0 && n(t.month);
		},
		children: a.map((e) => /* @__PURE__ */ b(se, {
			id: e.id,
			children: e.label
		}, e.id))
	});
}
//#endregion
//#region src/lib/components/dashboard/MonthStepper/MonthStepper.tsx
function yl({ month: e, onChange: t }) {
	let { t: n } = g(W), r = T(), i = Ce(() => Go({
		year: r.year,
		month: r.month
	}), [r.year, r.month]), a = Ho(e, i[0]), o = Ho(e, i[i.length - 1]);
	return /* @__PURE__ */ x("div", {
		className: "flex items-center justify-between gap-4",
		children: [/* @__PURE__ */ b(vl, {
			month: e,
			months: i,
			onChange: t
		}), /* @__PURE__ */ b(te, {
			previousLabel: n("month.previous"),
			nextLabel: n("month.next"),
			isPreviousDisabled: o,
			isNextDisabled: a,
			onPreviousPress: () => t(Vo(e, -1)),
			onNextPress: () => t(Vo(e, 1))
		})]
	});
}
//#endregion
//#region src/lib/components/dashboard/SwitchBonus/BonusRing.tsx
var bl = 60, xl = bl / 2, Sl = 26, Cl = 120, wl = 11, Tl = {
	newFtdClients: 0,
	netDepositUsd: 120,
	tradingVolumeUsd: 240
}, El = "stroke-5 transition-[stroke-width] group-hover/segment:stroke-7";
function Dl(e) {
	let t = e * Math.PI / 180, n = xl + Sl * Math.sin(t), r = xl - Sl * Math.cos(t);
	return `${n.toFixed(3)} ${r.toFixed(3)}`;
}
function Ol(e, t) {
	return `M ${Dl(e)} A ${Sl} ${Sl} 0 0 1 ${Dl(t)}`;
}
function kl({ metric: e }) {
	let t = _e(), n = Tl[e.metric] + wl, r = Tl[e.metric] + Cl - wl, i = n + (r - n) * e.ratio, a = Ol(n, r), o = t.triggerRef;
	return /* @__PURE__ */ x(Ke, { children: [/* @__PURE__ */ x("g", {
		ref: o,
		...t.triggerProps,
		className: "group/segment",
		children: [
			/* @__PURE__ */ b("path", {
				d: a,
				className: S(El, "stroke-borderPrimary")
			}),
			e.ratio > 0 && /* @__PURE__ */ b("path", {
				d: Ol(n, i),
				className: S(El, "stroke-brandPrimary")
			}),
			/* @__PURE__ */ b("path", {
				d: a,
				className: "stroke-transparent stroke-10"
			})
		]
	}), /* @__PURE__ */ x(pe, {
		anchor: t.anchor,
		children: [/* @__PURE__ */ b("span", {
			className: "block",
			children: e.label
		}), /* @__PURE__ */ b("span", {
			className: "block tabular-nums",
			children: e.value
		})]
	})] });
}
function Al({ metrics: e, label: t }) {
	return /* @__PURE__ */ b("svg", {
		role: "img",
		"aria-label": t,
		width: bl,
		height: bl,
		viewBox: `0 0 ${bl} ${bl}`,
		fill: "none",
		strokeLinecap: "round",
		className: "shrink-0 overflow-visible",
		children: e.map((e) => /* @__PURE__ */ b(kl, { metric: e }, e.metric))
	});
}
//#endregion
//#region src/lib/components/dashboard/SwitchBonus/SwitchBonusSummary.tsx
function jl({ view: e, isDetailed: t = !1 }) {
	let { action: n, earned: r, meta: i, target: a } = e;
	return /* @__PURE__ */ x("div", {
		className: "flex min-w-0 flex-col gap-1",
		children: [
			/* @__PURE__ */ x("p", {
				className: "flex flex-wrap items-baseline gap-x-1.5 tabular-nums",
				children: [/* @__PURE__ */ b("span", {
					className: "text-3xl font-semibold text-textPrimary",
					children: r
				}), a !== null && /* @__PURE__ */ x("span", {
					className: "text-xl font-medium text-textSecondary",
					children: ["/ ", a]
				})]
			}),
			/* @__PURE__ */ b("p", {
				className: "text-base text-textSecondary",
				children: n
			}),
			t && /* @__PURE__ */ b("p", {
				className: "text-sm text-textTertiary",
				children: i
			})
		]
	});
}
//#endregion
//#region src/lib/components/dashboard/SwitchBonus/SwitchBonusDetails.tsx
var Ml = 100;
function Nl({ view: e }) {
	let { t } = g(W), { switchBonusTermsUrl: n } = R(), { conditionsNote: r, conditionsTitle: i, metrics: a, tiers: o } = e;
	return /* @__PURE__ */ x("div", {
		className: "flex min-h-full flex-col gap-10",
		children: [
			/* @__PURE__ */ b(jl, {
				view: e,
				isDetailed: !0
			}),
			/* @__PURE__ */ x("section", {
				className: "flex flex-col gap-5",
				children: [/* @__PURE__ */ x("div", {
					className: "flex flex-wrap items-baseline justify-between gap-x-3",
					children: [/* @__PURE__ */ b("h3", {
						className: "text-base font-medium text-textPrimary",
						children: i
					}), /* @__PURE__ */ b("p", {
						className: "text-sm text-textTertiary",
						children: r
					})]
				}), /* @__PURE__ */ b("ul", {
					className: "flex flex-col gap-5",
					children: a.map((e) => /* @__PURE__ */ x("li", {
						className: "flex flex-col gap-2",
						children: [/* @__PURE__ */ x("div", {
							className: "flex items-baseline justify-between gap-3 text-base",
							children: [/* @__PURE__ */ b("span", {
								className: "text-textSecondary",
								children: e.label
							}), /* @__PURE__ */ b("span", {
								className: "tabular-nums text-textPrimary",
								children: e.value
							})]
						}), /* @__PURE__ */ b(ne, {
							"aria-label": e.label,
							value: e.ratio * Ml,
							size: "sm",
							className: "w-full"
						})]
					}, e.metric))
				})]
			}),
			/* @__PURE__ */ x("section", {
				className: "flex flex-col gap-3",
				children: [/* @__PURE__ */ b("h3", {
					className: "text-base font-medium text-textPrimary",
					children: t("widgets.switchBonus.tiersTitle")
				}), /* @__PURE__ */ b("ul", {
					className: "flex flex-col",
					children: o.map((e) => /* @__PURE__ */ x("li", {
						className: S("flex items-center justify-between gap-3 rounded-md px-3 py-2", e.isFocused && "bg-backgroundMuted"),
						children: [/* @__PURE__ */ x("div", {
							className: "flex min-w-0 flex-col",
							children: [/* @__PURE__ */ b("span", {
								className: "text-base font-medium text-textPrimary",
								children: e.name
							}), /* @__PURE__ */ b("span", {
								className: "text-sm text-textTertiary",
								children: e.caption
							})]
						}), /* @__PURE__ */ b("span", {
							className: "text-base font-medium tabular-nums text-textPrimary",
							children: e.amount
						})]
					}, e.name))
				})]
			}),
			/* @__PURE__ */ x("footer", {
				className: "mt-auto flex flex-col gap-4",
				children: [/* @__PURE__ */ x("div", {
					className: "flex flex-col gap-1 text-sm text-textSecondary",
					children: [/* @__PURE__ */ b("p", { children: t("widgets.switchBonus.rules.directClients") }), /* @__PURE__ */ b("p", { children: t("widgets.switchBonus.rules.notional") })]
				}), n !== "" && /* @__PURE__ */ x(u, {
					variant: "subtle",
					href: n,
					target: "_blank",
					rel: "noopener noreferrer",
					className: "gap-2 self-start text-base text-textPrimary",
					children: [t("widgets.switchBonus.terms"), /* @__PURE__ */ b(at, {
						name: "external-link",
						size: "sm"
					})]
				})]
			})
		]
	});
}
//#endregion
//#region src/lib/model/switchBonus.ts
var Pl = [
	"newFtdClients",
	"netDepositUsd",
	"tradingVolumeUsd"
];
//#endregion
//#region src/lib/components/dashboard/SwitchBonus/utils/switchBonusProgress.ts
function Fl(e, t, n) {
	let r = e.progress[n], i = t.targets[n], a = i <= 0 ? 1 : Math.min(Math.max(r / i, 0), 1);
	return {
		metric: n,
		current: r,
		target: i,
		remaining: Math.max(0, i - r),
		ratio: a,
		isMet: r >= i
	};
}
function Il(e, t) {
	return Pl.every((n) => e.progress[n] >= t.targets[n]);
}
function Ll(e) {
	let { tiers: t } = e, n = -1;
	t.forEach((t, r) => {
		Il(e, t) && (n = r);
	});
	let r = n >= 0 ? t[n] : null, i = t[n + 1] ?? null, a = i ?? t[t.length - 1], o = Pl.map((t) => Fl(e, a, t)), s = o.filter((e) => !e.isMet).sort((e, t) => e.ratio - t.ratio);
	return {
		earned: r?.amount ?? 0,
		currentTier: r,
		targetTier: i,
		focusTier: a,
		metrics: o,
		blocking: s,
		isZero: Pl.every((t) => e.progress[t] === 0)
	};
}
function Rl(e) {
	let t = je(e);
	return {
		daysLeft: t.compare(e),
		monthEnd: t
	};
}
function zl(e, t) {
	return !e || e.tiers.length === 0 ? !1 : t.compare(e.from) >= 0 && t.compare(e.to) <= 0;
}
//#endregion
//#region src/lib/components/dashboard/SwitchBonus/utils/buildSwitchBonusView.ts
var Bl = " · ", Vl = " / ", Hl = "; ", Ul = {
	newFtdClients: Q,
	netDepositUsd: zs,
	tradingVolumeUsd: Hs
};
function Wl({ metric: e, remaining: t }, { locale: n, t: r }) {
	return e === "newFtdClients" ? r("widgets.switchBonus.gap.newFtdClients", { count: t }) : e === "netDepositUsd" ? r("widgets.switchBonus.gap.netDepositUsd", { amount: Vs(t, n) }) : r("widgets.switchBonus.gap.tradingVolumeUsd", { amount: Hs(t, n) });
}
function Gl(e, t, n) {
	let { locale: r, t: i } = n;
	if (e.targetTier === null) return i("widgets.switchBonus.action.topTier", { date: nc(t, r) });
	if (e.isZero) return i("widgets.switchBonus.action.zero");
	let [a, ...o] = e.blocking, s = Wl(a, n);
	return o.length === 0 ? i("widgets.switchBonus.action.unlock", { gap: s }) : i("widgets.switchBonus.action.unlockMore", {
		gap: s,
		more: o.length
	});
}
function Kl(e, { daysLeft: t, monthEnd: n }, { locale: r, t: i }) {
	let a = i("widgets.switchBonus.meta.updated");
	return e.targetTier === null ? [i("widgets.switchBonus.meta.paidAfter", { date: nc(n, r) }), a].join(Bl) : [t === 0 ? i("widgets.switchBonus.meta.lastDay") : i("widgets.switchBonus.meta.daysLeft", { count: t }), a].join(Bl);
}
function ql({ metric: e, current: t, target: n, ratio: r }, { locale: i, t: a }) {
	let o = Ul[e];
	return {
		metric: e,
		label: a(`widgets.switchBonus.metrics.${e}`),
		value: [o(t, i), o(n, i)].join(Vl),
		ratio: r
	};
}
function Jl(e, t) {
	let { locale: n, t: r, today: i } = t, a = Ll(e), o = Rl(i), { focusTier: s, targetTier: c } = a, l = a.metrics.map((e) => ql(e, t)), u = e.tiers.map((e) => ({
		name: e.name,
		caption: r("widgets.switchBonus.tierCaption", {
			count: e.targets.newFtdClients,
			deposit: Vs(e.targets.netDepositUsd, n),
			volume: Hs(e.targets.tradingVolumeUsd, n)
		}),
		amount: zs(e.amount, n),
		isFocused: e === s
	}));
	return {
		earned: zs(a.earned, n),
		target: c === null ? null : zs(c.amount, n),
		action: Gl(a, o.monthEnd, t),
		meta: Kl(a, o, t),
		conditionsTitle: r("widgets.switchBonus.conditions.title", { tier: s.name }),
		conditionsNote: r(c === null ? "widgets.switchBonus.conditions.allMet" : "widgets.switchBonus.conditions.allRequired"),
		metrics: l,
		tiers: u,
		ringLabel: l.map((e) => `${e.label}: ${e.value}`).join(Hl)
	};
}
//#endregion
//#region src/lib/components/dashboard/SwitchBonus/SwitchBonusWidget.tsx
function Yl({ clientId: e, className: t }) {
	let { t: n } = g(W), i = q(), a = Se(), { data: o } = ps(e), [l, u] = _(!1), d = we(l);
	d.current = l;
	let f = vt(), p = zl(o, f);
	if (xe(() => () => {
		let e = document.activeElement === null || document.activeElement === document.body;
		if (!d.current || !e) return;
		let t = document.querySelector("main");
		t !== null && (t.hasAttribute("tabindex") || t.setAttribute("tabindex", "-1"), t.focus({ preventScroll: !0 }));
	}, [p]), xe(() => {
		p || u(!1);
	}, [p]), !p) return null;
	let m = Jl(o, {
		locale: i,
		t: n,
		today: f
	});
	return /* @__PURE__ */ x(r, {
		"aria-labelledby": a,
		className: t,
		children: [
			/* @__PURE__ */ x("div", {
				className: "flex min-h-8 flex-wrap items-center gap-x-4 gap-y-3",
				children: [/* @__PURE__ */ b(c, {
					id: a,
					level: 2,
					size: "2xs",
					children: n("widgets.switchBonus.title")
				}), /* @__PURE__ */ x(h, {
					variant: "secondary",
					onPress: () => u(!0),
					className: "ms-auto gap-0.5",
					children: [n("widgets.switchBonus.viewDetails"), /* @__PURE__ */ b(at, {
						name: "chevron-right",
						size: "sm",
						className: "rtl:-scale-x-100"
					})]
				})]
			}),
			/* @__PURE__ */ x("div", {
				className: "flex items-center gap-4",
				children: [/* @__PURE__ */ b("div", {
					className: "min-w-0 flex-1",
					children: /* @__PURE__ */ b(jl, { view: m })
				}), /* @__PURE__ */ b(Al, {
					metrics: m.metrics,
					label: m.ringLabel
				})]
			}),
			/* @__PURE__ */ b(s, {
				title: n("widgets.switchBonus.title"),
				width: 320,
				isOpen: l,
				onOpenChange: u,
				children: /* @__PURE__ */ b(Nl, { view: m })
			})
		]
	});
}
//#endregion
//#region src/lib/components/dashboard/TopSubIbs/TopSubIbsSkeleton.tsx
var Xl = [
	{
		amountWidth: "w-14.5",
		barWidth: "w-full"
	},
	{
		amountWidth: "w-14.5",
		barWidth: "w-1/5"
	},
	{
		amountWidth: "w-17.25",
		barWidth: "w-1/6"
	},
	{
		amountWidth: "w-17.25",
		barWidth: "w-1/8"
	},
	{
		amountWidth: "w-17.25",
		barWidth: "w-1/16"
	}
];
function Zl() {
	return /* @__PURE__ */ b("div", {
		"aria-busy": "true",
		className: "flex flex-col",
		children: Xl.map(({ amountWidth: e, barWidth: t }, n) => /* @__PURE__ */ x("div", {
			className: "flex flex-col gap-1 pt-3.5 pb-1.75",
			children: [/* @__PURE__ */ x("div", {
				className: "flex items-center gap-2 py-1.5",
				children: [/* @__PURE__ */ b(G, { className: "h-3 flex-1 rounded-sm" }), /* @__PURE__ */ b(G, { className: `h-3 shrink-0 rounded-sm ${e}` })]
			}), /* @__PURE__ */ b("div", {
				className: "h-1 overflow-hidden rounded-xs bg-backgroundMuted",
				children: /* @__PURE__ */ b("div", {
					className: `h-full opacity-60 ${t}`,
					children: /* @__PURE__ */ b(G, { className: "h-full rounded-xs" })
				})
			})]
		}, n))
	});
}
//#endregion
//#region src/lib/components/dashboard/TopSubIbs/utils/buildTopSubIbsView.ts
var Ql = 100, $l = 2;
function eu(e, t) {
	if (e.isZero() || !t.isPositive()) return 0;
	let n = e.divide(t).multiply(Ql).toNumber();
	return Math.max(n, $l);
}
function tu(e, t) {
	if (e.length === 0) return [];
	let [n, ...r] = e.map((e) => e.rewards), i = We.max(n, ...r);
	return e.map((e) => ({
		rowKey: e.rowKey,
		name: It(e.name, e.email),
		amount: Z(e.rewards, t),
		barPercent: eu(e.rewards, i)
	}));
}
//#endregion
//#region src/lib/components/dashboard/TopSubIbs/TopSubIbsWidget.tsx
var nu = "all";
function ru({ className: e, clientId: t, month: n }) {
	let { t: i } = g(W), a = q(), o = Eo(), { programSearch: s } = ko(), [c, l] = _(nu), u = hs(t, n, c), d = Qa(s, {
		[Pt]: J(n),
		[Nt]: nn(c)
	});
	function f() {
		u.refetch();
	}
	function p() {
		return c === "indirect" ? /* @__PURE__ */ b(ct, {
			align: "center",
			icon: "shapes",
			title: i("widgets.topSubIbs.emptyIndirect.title"),
			description: i("widgets.topSubIbs.emptyIndirect.description")
		}) : /* @__PURE__ */ b(ct, {
			align: "center",
			icon: "shapes",
			title: i("widgets.topSubIbs.empty.title"),
			description: i("widgets.topSubIbs.empty.description")
		});
	}
	function m() {
		let { data: e, isError: t, isPlaceholderData: n } = u, r = ls(e, n);
		return r === void 0 ? t ? /* @__PURE__ */ b(Co, { onRetry: f }) : /* @__PURE__ */ b(Zl, {}) : r.length === 0 ? p() : /* @__PURE__ */ b("ol", {
			"aria-label": i("widgets.topSubIbs.listLabel"),
			"aria-busy": n,
			className: S("flex flex-col transition-opacity", n && "opacity-60"),
			children: tu(r, a).map((e) => /* @__PURE__ */ x("li", {
				className: "flex flex-col gap-1 pt-3.5 pb-1.75",
				children: [/* @__PURE__ */ x("div", {
					className: "flex items-center justify-between gap-2 text-lg text-textPrimary",
					children: [/* @__PURE__ */ b(C, {
						text: e.name,
						className: "font-medium uppercase"
					}), /* @__PURE__ */ b("span", {
						className: "shrink-0 font-semibold tabular-nums",
						children: e.amount
					})]
				}), /* @__PURE__ */ b("div", {
					"aria-hidden": "true",
					className: "h-1 overflow-hidden rounded-xs bg-backgroundMuted",
					children: /* @__PURE__ */ b("div", {
						className: "h-full rounded-xs bg-brandPrimary",
						style: { inlineSize: `${e.barPercent}%` }
					})
				})]
			}, e.rowKey))
		});
	}
	return /* @__PURE__ */ b(r, {
		title: i("widgets.titles.topSubIbs"),
		action: /* @__PURE__ */ b(ys, { href: Za(o, U.subIbs, d) }),
		className: e,
		children: /* @__PURE__ */ x("div", {
			className: "flex flex-1 flex-col gap-2",
			children: [/* @__PURE__ */ b(vs, {
				value: c,
				onChange: l
			}), m()]
		})
	});
}
//#endregion
//#region src/lib/pages/Dashboard/DashboardPage.tsx
function iu() {
	let { program: e } = ko(), [t, n] = _(() => Bo(T()));
	return /* @__PURE__ */ x("div", {
		className: "flex flex-col gap-4",
		children: [
			/* @__PURE__ */ b(yl, {
				month: t,
				onChange: n
			}),
			/* @__PURE__ */ b(_l, {
				clientId: e.clientId,
				month: t
			}),
			/* @__PURE__ */ x("div", {
				className: "grid grid-cols-1 gap-4 xl:grid-cols-3",
				children: [
					/* @__PURE__ */ x("div", {
						className: "flex flex-col gap-4",
						children: [/* @__PURE__ */ b(Yl, { clientId: e.clientId }, e.clientId), /* @__PURE__ */ b(el, {
							clientId: e.clientId,
							month: t,
							className: "flex-1"
						})]
					}),
					/* @__PURE__ */ b(r, {
						className: "xl:col-span-2",
						children: /* @__PURE__ */ b(Ic, {
							clientId: e.clientId,
							month: t
						})
					}),
					/* @__PURE__ */ b(ru, {
						clientId: e.clientId,
						month: t
					}),
					/* @__PURE__ */ b(xc, {
						clientId: e.clientId,
						month: t,
						className: "xl:col-span-2"
					})
				]
			})
		]
	});
}
//#endregion
//#region src/lib/components/clients/ClientColumns/clientColumns.tsx
var au = "—";
function ou({ ibExternalId: e, locale: t, t: n }) {
	let r = n("clients.direct");
	return [
		{
			id: "client",
			label: n("clients.columns.client"),
			isRowHeader: !0,
			width: "2fr",
			minWidth: 280,
			skeleton: "twoLines",
			cell: (e) => /* @__PURE__ */ b(C, {
				text: It(e.name, e.email),
				className: "block"
			}),
			cellProps: (e) => ({ subtext: `#${e.externalId}` })
		},
		{
			id: "email",
			label: n("clients.columns.email"),
			width: "2fr",
			minWidth: 260,
			cell: (e) => e.email === "" ? au : /* @__PURE__ */ b(C, {
				text: e.email,
				className: "block"
			}),
			cellProps: (e) => ({ isMuted: e.email === "" })
		},
		{
			id: "volumeLots",
			label: n("clients.columns.volumeLots"),
			align: "end",
			isSortable: !0,
			width: "1fr",
			minWidth: 120,
			cell: (e) => Us(e.volumeLots, t),
			cellProps: (e) => ({ isMuted: e.volumeLots.isZero() })
		},
		{
			id: "rewards",
			label: n("clients.columns.rebate"),
			align: "end",
			isSortable: !0,
			width: "1fr",
			minWidth: 124,
			cell: (e) => Z(e.rewards, t),
			cellProps: (e) => ({ isMuted: e.rewards.isZero() })
		},
		{
			id: "status",
			label: n("clients.columns.status"),
			width: "1fr",
			minWidth: 140,
			skeleton: "pill",
			fitContent: Lt.map((e) => /* @__PURE__ */ b(_s, { status: e }, e)),
			cell: (e) => /* @__PURE__ */ b(_s, { status: e.status })
		},
		{
			id: "balance",
			label: n("clients.columns.balance"),
			align: "end",
			isSortable: !0,
			width: "1fr",
			minWidth: 136,
			cell: (e) => Z(e.balance, t),
			cellProps: (e) => ({ isMuted: e.balance.isZero() })
		},
		{
			id: "parentIbName",
			label: n("clients.columns.registeredUnder"),
			width: "1fr",
			minWidth: 240,
			cell: (t) => /* @__PURE__ */ b(C, {
				text: zt(t, e) ? r : Bt(t),
				className: "block"
			})
		},
		{
			id: "subClients",
			label: n("clients.columns.subClients"),
			align: "end",
			isSortable: !0,
			width: "1fr",
			minWidth: 120,
			cell: (e) => e.subClients > 0 ? Q(e.subClients, t) : au,
			cellProps: (e) => ({ isMuted: e.subClients === 0 })
		},
		{
			id: "registeredAt",
			label: n("clients.columns.registered"),
			align: "end",
			isSortable: !0,
			width: "1fr",
			minWidth: 148,
			cell: (e) => qs(e.registeredAt, t)
		}
	];
}
//#endregion
//#region src/lib/components/clients/ListPeriodFilter/ListPeriodSelect.tsx
function su({ value: e, onChange: t }) {
	let { t: n } = g(W), r = q(), i = we(null), [a, s] = _(!1), [c, l] = _(!1), u = T(), ee = Go(Bo(u)), h = n("list.periodLabel"), te = e.type === "custom" ? e.range.from.toString() : null, ne = e.type === "custom" ? e.range.to.toString() : null, ie = Ce(() => te === null || ne === null ? null : {
		start: Re(te),
		end: Re(ne)
	}, [te, ne]), ae = is(e) !== is(es(u)), oe = e.type === "month" ? J(e.month) : Zo, se = e.type === "month" ? rc(e.month, r) : Js(e.range, r), ce = (e) => {
		s(!1), t({
			type: "month",
			month: e
		});
	};
	return /* @__PURE__ */ x(Ke, { children: [/* @__PURE__ */ x(m, {
		isOpen: a,
		onOpenChange: s,
		placement: "bottom end",
		children: [/* @__PURE__ */ b(o, {
			ref: i,
			"aria-label": `${h}: ${se}`,
			isOpen: a || c,
			isFilled: ae,
			children: se
		}), /* @__PURE__ */ x(d, {
			"aria-label": h,
			selectionMode: "single",
			selectedKeys: [oe],
			children: [
				ee.map((e) => /* @__PURE__ */ b(f, {
					id: J(e),
					onAction: () => ce(e),
					children: rc(e, r)
				}, J(e))),
				/* @__PURE__ */ b(p, {}),
				/* @__PURE__ */ b(f, {
					id: Zo,
					onAction: () => {
						s(!1), l(!0);
					},
					children: n("period.customRange")
				})
			]
		})]
	}), /* @__PURE__ */ b(re, {
		"aria-label": h,
		triggerRef: i,
		isOpen: c,
		onOpenChange: l,
		value: ie,
		minValue: Lo,
		maxValue: u,
		onChange: (e) => t({
			type: "custom",
			range: {
				from: e.start,
				to: e.end
			}
		})
	})] });
}
//#endregion
//#region src/lib/components/clients/ListPeriodFilter/buildListPeriodFilter.tsx
function cu(e) {
	return mt({
		defaultValue: es(e),
		isScope: !0,
		parse: (t) => rs(t, e),
		serialize: is,
		render: ({ value: e, onChange: t }) => /* @__PURE__ */ b(su, {
			value: e,
			onChange: t
		})
	});
}
//#endregion
//#region src/lib/utils/csv.ts
var lu = "﻿", uu = "\r\n", du = /[",\r\n]/, fu = /^[=+@\t\r-]/, pu = "text/csv;charset=utf-8";
function mu(e) {
	return du.test(e) ? `"${e.replaceAll("\"", "\"\"")}"` : e;
}
function hu(e) {
	return fu.test(e) ? `'${e}` : e;
}
function gu(e, t) {
	let n = e.value(t) ?? "";
	return mu(e.isNumber ? n : hu(n));
}
function _u(e, t) {
	return `${lu}${[e.map((e) => mu(e.header)).join(","), ...t.map((t) => e.map((e) => gu(e, t)).join(","))].join(uu)}${uu}`;
}
//#endregion
//#region src/lib/utils/exportColumns.ts
var vu = 2, yu = 2, bu = 1, xu = 4;
function Su(e, t) {
	return e.toFixed(t, Ge.HalfUp);
}
function $(e) {
	return e === null ? null : Su(e, vu);
}
function Cu(e) {
	let { year: t, month: n, day: r, hour: i, minute: a } = y(Me(e, w())), o = (e) => String(e).padStart(2, "0");
	return `${t}-${o(n)}-${o(r)} ${o(i)}:${o(a)}`;
}
function wu(e) {
	return e === null ? null : String(e);
}
function Tu(e) {
	if (e === null) return null;
	let t = e.trend === "negative" ? "-" : "";
	return e.unit === "count" ? `${t}${Su(e.value, 0)}` : `${t}${Su(e.value, bu)}%`;
}
function Eu(e, t, n, r) {
	return [{
		header: e,
		isNumber: !0,
		value: (e) => n(t(e).value)
	}, {
		header: r("list.changeColumn", { column: e }),
		isNumber: !0,
		value: (e) => Tu(t(e).delta)
	}];
}
function Du({ ibExternalId: e, t }) {
	let n = t("clients.direct");
	return [
		{
			header: t("clients.columns.clientId"),
			value: (e) => e.externalId
		},
		{
			header: t("clients.columns.client"),
			value: (e) => e.name
		},
		{
			header: t("clients.columns.email"),
			value: (e) => e.email
		},
		{
			header: t("clients.columns.volumeLots"),
			isNumber: !0,
			value: (e) => Su(e.volumeLots, yu)
		},
		{
			header: t("clients.columns.rebate"),
			isNumber: !0,
			value: (e) => $(e.rewards)
		},
		{
			header: t("clients.columns.status"),
			value: (e) => t(`status.${e.status}`)
		},
		{
			header: t("clients.columns.balance"),
			isNumber: !0,
			value: (e) => $(e.balance)
		},
		{
			header: t("clients.columns.registeredUnder"),
			value: (t) => zt(t, e) ? n : Bt(t)
		},
		{
			header: t("clients.columns.subClients"),
			isNumber: !0,
			value: (e) => wu(e.subClients)
		},
		{
			header: t("clients.columns.registered"),
			value: (e) => e.registeredAt.toString()
		}
	];
}
function Ou({ t: e }) {
	return [
		{
			header: e("subIbs.columns.subIb"),
			value: (e) => It(e.name, e.email)
		},
		{
			header: e("subIbs.columns.level"),
			isNumber: !0,
			value: (e) => wu(e.level)
		},
		{
			header: e("subIbs.columns.clients"),
			isNumber: !0,
			value: (e) => wu(e.clients)
		},
		...Eu(e("subIbs.columns.totalDepositAmount"), (e) => e.totalDepositAmount, $, e),
		...Eu(e("subIbs.columns.totalDeposits"), (e) => e.totalDeposits, wu, e),
		{
			header: e("subIbs.columns.averageDepositAmount"),
			isNumber: !0,
			value: (e) => $(e.averageDepositAmount)
		},
		...Eu(e("subIbs.columns.netDeposits"), (e) => e.netDeposits, $, e),
		...Eu(e("subIbs.columns.totalRebate"), (e) => e.totalRebate, $, e)
	];
}
function ku({ t: e }) {
	return [
		{
			header: e("rebates.columns.client"),
			value: (e) => e.name
		},
		{
			header: e("rebates.csv.email"),
			value: (e) => e.email
		},
		{
			header: e("rebates.columns.level"),
			isNumber: !0,
			value: (e) => wu(e.level)
		},
		{
			header: e("rebates.columns.account"),
			value: (e) => e.account
		},
		{
			header: e("rebates.columns.side"),
			value: (e) => e.side?.toUpperCase() ?? null
		},
		{
			header: e("rebates.columns.symbol"),
			value: (e) => e.symbol
		},
		{
			header: e("rebates.columns.volume"),
			isNumber: !0,
			value: (e) => Su(e.lots, yu)
		},
		{
			header: e("rebates.csv.volumeUsd"),
			isNumber: !0,
			value: (e) => $(e.volume)
		},
		{
			header: e("rebates.columns.rebate"),
			isNumber: !0,
			value: (e) => Su(e.rewards, xu)
		},
		{
			header: e("rebates.columns.tradedAt"),
			value: (e) => Cu(e.tradedAt)
		}
	];
}
//#endregion
//#region src/lib/utils/exportFile.ts
var Au = 6e4;
function ju(e, t) {
	return `ib-${e}-${t.from}_${t.to}.csv`;
}
function Mu(e, t) {
	let n = URL.createObjectURL(e), r = document.createElement("a");
	r.href = n, r.download = t, r.click(), window.setTimeout(() => URL.revokeObjectURL(n), Au);
}
//#endregion
//#region src/lib/hooks/listQueries.ts
function Nu(e) {
	return {
		status: e.status ?? void 0,
		hideZeroCommission: e.isZeroCommissionHidden ? !0 : void 0,
		search: e.search ?? void 0
	};
}
function Pu(e) {
	return {
		levels: e.levels ?? void 0,
		search: e.search ?? void 0
	};
}
function Fu(e, t, n, r) {
	let i = z(), { rangeKey: a, timeRange: o } = ss(r), s = {
		...t,
		...Nu(n)
	};
	return v({
		...H,
		queryKey: V.clients(e ?? "", {
			...s,
			range: a
		}),
		queryFn: ({ signal: t }) => i.getClients(e ?? "", {
			...s,
			...o
		}, t),
		enabled: e !== void 0,
		placeholderData: Te
	});
}
function Iu(e, t, n, r, { enabled: i }) {
	let a = z(), { rangeKey: o, timeRange: s, compare: c } = ss(r), l = {
		...t,
		...Pu(n)
	};
	return v({
		...H,
		queryKey: V.subIbs(e ?? "", {
			...l,
			range: o,
			compare: c
		}),
		queryFn: ({ signal: t }) => a.getSubIbs(e ?? "", {
			...l,
			...s,
			compare: c
		}, t),
		enabled: i && e !== void 0,
		placeholderData: Te
	});
}
function Lu(e) {
	let t = z();
	return v({
		...H,
		queryKey: V.subIbLevels(e ?? ""),
		queryFn: ({ signal: n }) => t.getSubIbLevels(e ?? "", n),
		enabled: e !== void 0
	});
}
//#endregion
//#region src/lib/hooks/rebatesQueries.ts
function Ru(e) {
	return {
		levels: e.levels ?? void 0,
		search: e.search ?? void 0
	};
}
function zu(e, t) {
	let n = z(), { rangeKey: r, timeRange: i } = Y(t);
	return v({
		...H,
		queryKey: V.rebateLevels(e ?? "", r),
		queryFn: ({ signal: t }) => n.getRebateLevels(e ?? "", i, t),
		enabled: e !== void 0
	});
}
function Bu(e, t, n, r, { enabled: i }) {
	let a = z(), { rangeKey: o, timeRange: s } = Y(r), c = {
		...t,
		...Ru(n)
	};
	return v({
		...H,
		queryKey: V.rebates(e ?? "", {
			...c,
			range: o
		}),
		queryFn: ({ signal: t }) => a.getRebates(e ?? "", {
			...c,
			...s
		}, t),
		enabled: i && e !== void 0,
		placeholderData: Te
	});
}
function Vu(e, t) {
	let n = z(), { rangeKey: r, timeRange: i } = Y(t);
	return v({
		...H,
		queryKey: V.rebatesTotalVolume(e ?? "", r),
		queryFn: ({ signal: t }) => n.getRebatesTotalVolume(e ?? "", i, t),
		enabled: e !== void 0
	});
}
function Hu(e, t) {
	let n = z(), { rangeKey: r, timeRange: i } = Y(t);
	return v({
		...H,
		queryKey: V.rebatesTotalRebates(e ?? "", r),
		queryFn: ({ signal: t }) => n.getRebatesTotalRebates(e ?? "", i, t),
		enabled: e !== void 0
	});
}
function Uu(e, t) {
	let n = z(), { rangeKey: r, timeRange: i } = Y(t);
	return v({
		...H,
		queryKey: V.rebatesTopSymbol(e ?? "", r),
		queryFn: ({ signal: t }) => n.getRebatesTopSymbol(e ?? "", i, t),
		enabled: e !== void 0
	});
}
function Wu(e, t) {
	let n = z(), { rangeKey: r, timeRange: i } = Y(t);
	return v({
		...H,
		queryKey: V.rebatesTopClient(e ?? "", r),
		queryFn: ({ signal: t }) => n.getRebatesTopClient(e ?? "", i, t),
		enabled: e !== void 0
	});
}
function Gu(e, t, n) {
	let r = z(), { rangeKey: i, timeRange: a } = Y(t);
	return v({
		...H,
		queryKey: V.rebateBreakdown(e ?? "", i, n),
		queryFn: ({ signal: t }) => r.getRebateBreakdown(e ?? "", {
			type: n,
			...a
		}, t),
		enabled: e !== void 0
	});
}
//#endregion
//#region src/lib/hooks/exportMutations.ts
function Ku(e, t, n, r) {
	let { t: i } = g(W), { rangeKey: a, timeRange: o } = t;
	return De({
		mutationFn: async () => {
			let t = await r(o);
			return {
				blob: new Blob([_u(n, t)], { type: pu }),
				fileName: ju(e, a)
			};
		},
		onSuccess: ({ blob: e, fileName: t }) => {
			Mu(e, t);
		},
		onError: () => {
			ge.danger({
				title: i("list.exportFailed.title"),
				description: i("list.exportFailed.description")
			});
		}
	});
}
function qu(e, t, n, r) {
	let i = z(), { t: a } = g(W), { externalId: o } = oo(), { sortBy: s, sortOrder: c } = t, l = {
		sortBy: s,
		sortOrder: c,
		...Nu(n)
	}, u = Du({
		ibExternalId: o,
		t: a
	});
	return Ku("clients", ss(r), u, (t) => i.getAllClients(e, {
		...l,
		...t
	}));
}
function Ju(e, t, n, r) {
	let i = z(), { t: a } = g(W), { sortBy: o, sortOrder: s } = t, c = {
		sortBy: o,
		sortOrder: s,
		...Pu(n)
	}, l = Ou({ t: a }), u = ss(r);
	return Ku("sub-ibs", u, l, (t) => i.getAllSubIbs(e, {
		...c,
		...t,
		compare: u.compare
	}));
}
function Yu(e, t, n, r) {
	let i = z(), { t: a } = g(W), { sortBy: o, sortOrder: s } = t, c = {
		sortBy: o,
		sortOrder: s,
		...Ru(n)
	}, l = ku({ t: a });
	return Ku("rebates", Y(r), l, (t) => i.getAllRebates(e, {
		...c,
		...t
	}));
}
//#endregion
//#region src/lib/pages/MyClients/MyClientsPage.tsx
function Xu() {
	let { t: e } = g(W), t = q(), { program: n } = ko(), r = nt(), { externalId: i } = oo(), a = ht({
		"aria-label": e("clients.tableLabel"),
		columns: ou({
			ibExternalId: i,
			locale: t,
			t: e
		}),
		defaultSort: {
			by: "rewards",
			order: "desc"
		},
		getRowKey: (e) => e.rowKey,
		pageSize: 10,
		searchParams: r,
		filters: {
			[Mt]: {
				type: "search",
				label: e("clients.search.label"),
				placeholder: e("clients.search.placeholder"),
				defaultValue: "",
				minLength: 2
			},
			status: {
				type: "chips",
				label: e("clients.filters.label"),
				defaultValue: "all",
				options: [{
					value: "all",
					label: e("clients.filters.all")
				}, ...Lt.map((t) => ({
					value: t,
					label: e(`clients.filters.${t}`)
				}))]
			},
			hideZero: {
				type: "checkbox",
				label: e("clients.filters.hideZeroRebates"),
				defaultValue: !1
			},
			[Pt]: cu(T())
		}
	}), o = Vt(a.filters), s = a.filters[Pt], c = qu(n.clientId, a.requestParams, o, s), l = Fu(n.clientId, a.requestParams, o, s);
	return /* @__PURE__ */ x(a.Frame, { children: [/* @__PURE__ */ b(a.Toolbar, { children: /* @__PURE__ */ b(h, {
		variant: "secondary",
		iconStart: "download",
		isPending: c.isPending,
		onPress: () => c.mutate(),
		children: e("list.exportCsv")
	}) }), /* @__PURE__ */ b(a.Table, {
		query: l,
		headerVariant: "plain",
		emptyState: {
			icon: "shapes",
			title: e("clients.empty.title"),
			description: e("clients.empty.description")
		},
		noResultsState: {
			title: e("clients.noResults.title"),
			description: e("clients.noResults.description")
		}
	})] });
}
//#endregion
//#region src/lib/components/clients/SubIbColumns/subIbColumns.tsx
var Zu = { decimals: 0 }, Qu = "—";
function $u(e, t) {
	return e === null ? Qu : Q(e, t);
}
function ed(e, t, n) {
	return e === null ? Qu : Z(e, t, n);
}
function td(e, t) {
	return /* @__PURE__ */ b(st, {
		variant: "semantic",
		size: "sm",
		weight: "regular",
		trend: e.delta?.trend ?? "neutral",
		value: e.delta === null ? null : Ws(e.delta, t)
	});
}
function nd({ locale: e, t }) {
	return [
		{
			id: "subIb",
			label: t("subIbs.columns.subIb"),
			isRowHeader: !0,
			width: "2fr",
			minWidth: 220,
			skeleton: "twoLines",
			cell: (e) => /* @__PURE__ */ b(C, {
				text: It(e.name, e.email),
				className: "block"
			}),
			cellProps: (e) => ({ subtext: t("levelFilter.option", { level: e.level }) })
		},
		{
			id: "clients",
			label: t("subIbs.columns.clients"),
			align: "end",
			isSortable: !0,
			width: "1fr",
			minWidth: 110,
			cell: (t) => $u(t.clients, e)
		},
		{
			id: "totalDepositAmount",
			label: t("subIbs.columns.totalDepositAmount"),
			align: "end",
			isSortable: !0,
			width: "1fr",
			minWidth: 150,
			skeleton: "twoLines",
			cell: (t) => ed(t.totalDepositAmount.value, e, Zu),
			cellProps: (t) => ({ delta: td(t.totalDepositAmount, e) })
		},
		{
			id: "totalDeposits",
			label: t("subIbs.columns.totalDeposits"),
			align: "end",
			isSortable: !0,
			width: "1fr",
			minWidth: 120,
			skeleton: "twoLines",
			cell: (t) => $u(t.totalDeposits.value, e),
			cellProps: (t) => ({ delta: td(t.totalDeposits, e) })
		},
		{
			id: "averageDepositAmount",
			label: t("subIbs.columns.averageDepositAmount"),
			align: "end",
			isSortable: !0,
			width: "1fr",
			minWidth: 130,
			cell: (t) => ed(t.averageDepositAmount, e, Zu)
		},
		{
			id: "netDeposits",
			label: t("subIbs.columns.netDeposits"),
			align: "end",
			isSortable: !0,
			width: "1fr",
			minWidth: 140,
			skeleton: "twoLines",
			cell: (t) => ed(t.netDeposits.value, e, Zu),
			cellProps: (t) => ({ delta: td(t.netDeposits, e) })
		},
		{
			id: "totalRebate",
			label: t("subIbs.columns.totalRebate"),
			align: "end",
			isSortable: !0,
			width: "1fr",
			minWidth: 140,
			skeleton: "twoLines",
			cell: (t) => ed(t.totalRebate.value, e),
			cellProps: (t) => ({ delta: td(t.totalRebate, e) })
		}
	];
}
//#endregion
//#region src/lib/components/shared/LevelFilter/buildLevelOptions.ts
function rd(e, t) {
	let n = en(e).sort((e, t) => e - t), r = e.includes(1) ? [{
		value: "1",
		label: t.direct
	}] : [], i = n.length > 0 ? [{
		value: $t,
		label: t.indirect
	}] : [], a = n.map((e) => ({
		value: String(e),
		label: t.option(e)
	}));
	return [
		{
			value: "all",
			label: t.all
		},
		...r,
		...i,
		...a
	];
}
//#endregion
//#region src/lib/pages/MySubIbs/MySubIbsPage.tsx
var id = 320;
function ad() {
	let { t: e } = g(W), t = q(), { program: n } = ko(), r = nt(), i = Lu(n.clientId), a = i.data ?? [], o = ht({
		"aria-label": e("subIbs.tableLabel"),
		columns: nd({
			locale: t,
			t: e
		}),
		defaultSort: {
			by: "totalRebate",
			order: "desc"
		},
		getRowKey: (e) => e.rowKey,
		pageSize: 10,
		searchParams: r,
		filters: {
			[Mt]: {
				type: "search",
				label: e("subIbs.search.label"),
				placeholder: e("subIbs.search.placeholder"),
				defaultValue: "",
				minLength: 2,
				isStandalone: !0,
				width: id
			},
			[Nt]: {
				type: "select",
				label: e("subIbs.filters.label"),
				defaultValue: "all",
				options: rd(a, {
					all: e("levelFilter.all"),
					direct: e("levelFilter.direct"),
					indirect: e("levelFilter.indirect"),
					option: (t) => e("levelFilter.option", { level: t })
				})
			},
			[Pt]: cu(T())
		}
	}), s = Gi(o.filters, a), c = o.filters[Pt], l = Ju(n.clientId, o.requestParams, s, c), u = Iu(n.clientId, o.requestParams, s, c, { enabled: !i.isPending });
	return /* @__PURE__ */ x(o.Frame, { children: [/* @__PURE__ */ b(o.Toolbar, { children: /* @__PURE__ */ b(h, {
		variant: "secondary",
		iconStart: "download",
		isPending: l.isPending,
		onPress: () => l.mutate(),
		children: e("list.exportCsv")
	}) }), /* @__PURE__ */ b(o.Table, {
		query: u,
		headerVariant: "plain",
		emptyState: {
			icon: "shapes",
			title: e("subIbs.empty.title"),
			description: e("subIbs.empty.description")
		},
		noResultsState: {
			title: e("subIbs.noResults.title"),
			description: e("subIbs.noResults.description")
		}
	})] });
}
//#endregion
//#region src/lib/components/shared/TradingSymbolIcon/TradingSymbolIcon.tsx
function od({ size: e, symbol: t }) {
	let { symbolIconsBaseUrl: n } = R();
	return /* @__PURE__ */ b(ft, {
		symbol: t,
		size: e,
		logoUrls: pt(n, t, { preferPair: !0 })
	});
}
//#endregion
//#region src/lib/components/rebates/RebateBreakdown/BreakdownViewToggle.tsx
function sd({ onChange: e, value: t }) {
	let { t: n } = g(W);
	function r(t) {
		let n = on.find((e) => e === t);
		n !== void 0 && e(n);
	}
	return /* @__PURE__ */ x(fe, {
		"aria-label": n("rebates.breakdown.viewLabel"),
		selectedKey: t,
		onSelectionChange: r,
		children: [/* @__PURE__ */ b(de, {
			id: "client",
			children: n("rebates.breakdown.byClient")
		}), /* @__PURE__ */ b(de, {
			id: "pair",
			children: n("rebates.breakdown.byPair")
		})]
	});
}
//#endregion
//#region src/lib/components/rebates/RebateBreakdown/RebateBreakdown.tsx
var cd = [
	"bg-brandPrimary",
	"bg-brandPrimary/86",
	"bg-brandPrimary/74",
	"bg-brandPrimary/63",
	"bg-brandPrimary/54",
	"bg-brandPrimary/46",
	"bg-brandPrimary/38",
	"bg-brandPrimary/31"
], ld = "bg-textTertiary/35", ud = "bg-brandPrimary", dd = "bg-textTertiary", fd = "—", pd = "other", md = 20, hd = 100, gd = 4, _d = 10, vd = Array.from({ length: 9 }, (e, t) => t);
function yd(e, t, n) {
	if (!t) return {
		flexGrow: Math.max(e.amount.toNumber(), 0),
		flexBasis: 0
	};
	let r = n.isZero() ? 0 : e.amount.divide(n).multiply(hd).toNumber();
	return {
		flexGrow: 0,
		flexShrink: 0,
		flexBasis: `${Math.min(Math.max(r, gd), _d)}%`
	};
}
function bd({ clientId: e, month: t }) {
	let { t: n } = g(W), i = q(), [a, o] = _("pair"), [s, c] = _(null), l = Gu(e, t, a);
	function u() {
		l.refetch();
	}
	function d(e) {
		o(e), c(null);
	}
	function f(e, t) {
		return t ? ld : cd[Math.min(e, cd.length - 1)];
	}
	function p(e, t) {
		return e === s ? t ? dd : ud : f(e, t);
	}
	function m(e) {
		let t = Q(e, i);
		return n(a === "client" ? "rebates.breakdown.otherClients" : "rebates.breakdown.otherPairs", {
			count: e,
			value: t
		});
	}
	function ee(e) {
		let t = e.data.map((e, t) => ({
			key: String(t),
			label: e.name ?? fd,
			symbol: a === "pair" && e.name !== null ? e.name : void 0,
			amount: e.amount,
			lots: e.lots
		})), { remaining: n } = e;
		if (n.total === 0) return {
			entries: t,
			otherIndex: null
		};
		let r = {
			key: pd,
			label: m(n.total),
			amount: n.amount,
			lots: n.lots
		};
		return {
			entries: [...t, r],
			otherIndex: t.length
		};
	}
	function h() {
		return /* @__PURE__ */ x("div", {
			className: "flex flex-col gap-6",
			children: [/* @__PURE__ */ b("div", {
				className: "px-2",
				children: /* @__PURE__ */ b(G, { className: "h-4 rounded-full" })
			}), /* @__PURE__ */ b("div", {
				className: "grid grid-cols-1 gap-x-4 gap-y-1 sm:grid-cols-2 lg:grid-flow-col lg:grid-cols-3 lg:grid-rows-3",
				children: vd.map((e) => /* @__PURE__ */ x("div", {
					className: "flex items-center gap-2 px-4 py-2",
					children: [
						/* @__PURE__ */ b(G, { className: "size-2.5 shrink-0 rounded-full" }),
						/* @__PURE__ */ b(X, {
							lineClassName: "h-6",
							className: "w-24"
						}),
						/* @__PURE__ */ x("div", {
							className: "ms-auto flex flex-col items-end",
							children: [/* @__PURE__ */ b(X, {
								lineClassName: "h-6",
								className: "w-14"
							}), /* @__PURE__ */ b(X, {
								lineClassName: "h-4",
								className: "w-10"
							})]
						})
					]
				}, e))
			})]
		});
	}
	function te() {
		let { data: e, isError: t } = l;
		if (e === void 0) return t ? /* @__PURE__ */ b(Co, { onRetry: u }) : h();
		let { entries: r, otherIndex: a } = ee(e);
		if (r.length === 0) return /* @__PURE__ */ b("p", {
			className: "py-6 text-center text-base text-textSecondary",
			children: n("rebates.breakdown.empty")
		});
		let o = r.length - 1, d = r.reduce((e, t) => e.plus(t.amount), We.from(0));
		return /* @__PURE__ */ x("div", {
			className: "flex flex-col gap-6",
			children: [/* @__PURE__ */ b("div", {
				"aria-hidden": "true",
				className: "flex h-4 items-center gap-0.5 px-2",
				children: r.map((e, t) => /* @__PURE__ */ b("div", {
					className: S("min-w-2 transition-[height] duration-200 ease-out", t === s ? "h-4" : "h-3", t === 0 && "rounded-s-full", t === o && "rounded-e-full", p(t, t === a)),
					style: yd(e, t === a, d),
					onMouseEnter: () => c(t),
					onMouseLeave: () => c(null)
				}, e.key))
			}), /* @__PURE__ */ b("ul", {
				className: "grid grid-cols-1 gap-x-4 gap-y-1 sm:grid-cols-2 lg:grid-flow-col lg:grid-cols-3 lg:grid-rows-3",
				children: r.map((e, t) => /* @__PURE__ */ x("li", {
					className: S("flex min-w-0 items-center gap-2 rounded-md px-4 py-2", t === s && "bg-backgroundHover"),
					onMouseEnter: () => c(t),
					onMouseLeave: () => c(null),
					children: [
						/* @__PURE__ */ b("span", {
							"aria-hidden": "true",
							className: S("size-2.5 shrink-0 rounded-full", f(t, t === a))
						}),
						e.symbol !== void 0 && /* @__PURE__ */ b(od, {
							symbol: e.symbol,
							size: md
						}),
						/* @__PURE__ */ b(C, {
							text: e.label,
							className: "min-w-0 flex-1 text-lg font-medium text-textPrimary"
						}),
						/* @__PURE__ */ x("div", {
							className: "flex shrink-0 flex-col items-end text-end tabular-nums lining-nums",
							children: [/* @__PURE__ */ b("span", {
								className: "text-lg font-medium text-textPrimary",
								children: Z(e.amount, i)
							}), /* @__PURE__ */ b("span", {
								className: "text-sm text-textSecondary",
								children: n("rebates.breakdown.lots", { lots: Us(e.lots, i) })
							})]
						})
					]
				}, e.key))
			})]
		});
	}
	return /* @__PURE__ */ b(r, {
		title: n("rebates.breakdown.title"),
		action: /* @__PURE__ */ b(sd, {
			value: a,
			onChange: d
		}),
		children: te()
	});
}
//#endregion
//#region src/lib/components/rebates/RebateColumns/rebateColumns.tsx
var xd = "—", Sd = 4, Cd = 2, wd = 20;
function Td(e) {
	return !!e.name?.trim();
}
function Ed({ locale: e, t }) {
	return [
		{
			id: "client",
			label: t("rebates.columns.client"),
			isRowHeader: !0,
			width: "2fr",
			minWidth: 216,
			skeleton: "twoLines",
			cell: (e) => /* @__PURE__ */ b(C, {
				text: It(e.name, e.email),
				className: "block"
			}),
			cellProps: (e) => ({ subtext: Td(e) ? e.email : void 0 })
		},
		{
			id: "level",
			label: t("rebates.columns.level"),
			width: "1fr",
			minWidth: 72,
			cell: (e) => t("rebates.levelValue", { level: e.level })
		},
		{
			id: "account",
			label: t("rebates.columns.account"),
			width: "1fr",
			minWidth: 112,
			cell: (e) => e.account
		},
		{
			id: "side",
			label: t("rebates.columns.side"),
			width: "1fr",
			minWidth: 88,
			skeleton: "pill",
			cell: (e) => e.side === null ? xd : /* @__PURE__ */ b(ot, {
				direction: e.side,
				size: "sm"
			}),
			cellProps: (e) => ({ isMuted: e.side === null })
		},
		{
			id: "symbol",
			label: t("rebates.columns.symbol"),
			width: "1fr",
			minWidth: 144,
			cell: (e) => /* @__PURE__ */ x("span", {
				className: "flex min-w-0 items-center gap-2",
				children: [/* @__PURE__ */ b(od, {
					symbol: e.symbol,
					size: wd
				}), /* @__PURE__ */ b(C, {
					text: e.symbol,
					className: "min-w-0"
				})]
			})
		},
		{
			id: "volume",
			label: t("rebates.columns.volume"),
			align: "end",
			isSortable: !0,
			width: "1fr",
			minWidth: 132,
			skeleton: "twoLines",
			cell: (t) => Z(t.volume, e),
			cellProps: (t) => ({ subtext: Us(t.lots, e) })
		},
		{
			id: "rewards",
			label: t("rebates.columns.rebate"),
			align: "end",
			isSortable: !0,
			width: "1fr",
			minWidth: 120,
			cell: (t) => Z(t.rewards, e, {
				decimals: Sd,
				minDecimals: Cd
			})
		},
		{
			id: "tradedAt",
			label: t("rebates.columns.tradedAt"),
			isSortable: !0,
			width: "1fr",
			minWidth: 152,
			skeleton: "twoLines",
			cell: (t) => Xs(t.tradedAt, e),
			cellProps: (t) => ({ subtext: Zs(t.tradedAt, e) })
		}
	];
}
//#endregion
//#region src/lib/components/rebates/RebatesKpiRow/RebatesKpiRow.tsx
var Dd = "—", Od = 28;
function kd({ clientId: e, month: t }) {
	let { t: n } = g(W), r = q(), i = Vu(e, t), a = Hu(e, t), o = Uu(e, t), s = Wu(e, t);
	function c(e) {
		if (e !== null) return n("rebates.kpi.volumeShare", {
			lots: Us(e.totalLots, r),
			share: Rs(e.volumePercent, r)
		});
	}
	return /* @__PURE__ */ x("div", {
		className: "grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4",
		children: [
			/* @__PURE__ */ b(sl, {
				label: n("rebates.kpi.totalVolume.label"),
				query: i,
				toView: (e) => ({
					value: Us(e.totalVolume, r),
					unit: n("rebates.kpi.lotsUnit"),
					caption: n("rebates.kpi.totalVolume.caption", {
						count: e.totalSymbols,
						value: Q(e.totalSymbols, r)
					})
				})
			}),
			/* @__PURE__ */ b(sl, {
				label: n("rebates.kpi.totalRebates.label"),
				query: a,
				toView: (e) => ({ value: Z(e.totalRebates, r) })
			}),
			/* @__PURE__ */ b(sl, {
				label: n("rebates.kpi.topSymbol.label"),
				query: o,
				toView: (e) => ({
					value: e?.symbol ?? Dd,
					valueIcon: e === null ? void 0 : /* @__PURE__ */ b(od, {
						symbol: e.symbol,
						size: Od
					}),
					caption: c(e),
					isValueTruncated: !0
				})
			}),
			/* @__PURE__ */ b(sl, {
				label: n("rebates.kpi.topClient.label"),
				query: s,
				toView: (e) => ({
					value: e?.name ?? Dd,
					caption: c(e),
					isValueTruncated: !0
				})
			})
		]
	});
}
//#endregion
//#region src/lib/pages/Rebates/RebatesPage.tsx
var Ad = 320;
function jd() {
	let { t: e } = g(W), t = q(), { program: n } = ko(), r = nt(), [i, a] = _(() => Bo(T())), o = zu(n.clientId, i), s = o.data ?? [], c = ht({
		"aria-label": e("rebates.tableLabel"),
		columns: Ed({
			locale: t,
			t: e
		}),
		defaultSort: {
			by: "tradedAt",
			order: "desc"
		},
		getRowKey: (e) => e.rowKey,
		pageSize: 10,
		searchParams: r,
		filters: {
			[Mt]: {
				type: "search",
				label: e("rebates.search.label"),
				placeholder: e("rebates.search.placeholder"),
				defaultValue: "",
				minLength: 2,
				isStandalone: !0,
				width: Ad
			},
			[Nt]: {
				type: "select",
				label: e("rebates.filters.level.label"),
				defaultValue: "all",
				options: rd(s, {
					all: e("levelFilter.all"),
					direct: e("levelFilter.direct"),
					indirect: e("levelFilter.indirect"),
					option: (t) => e("levelFilter.option", { level: t })
				})
			}
		}
	}), l = sn(c.filters, s), u = Yu(n.clientId, c.requestParams, l, i), d = Bu(n.clientId, c.requestParams, l, i, { enabled: !o.isPending });
	function f(e) {
		a(e), c.page !== 1 && c.setPage(1);
	}
	return /* @__PURE__ */ x("div", {
		className: "flex flex-col gap-4",
		children: [
			/* @__PURE__ */ b(yl, {
				month: i,
				onChange: f
			}),
			/* @__PURE__ */ b(kd, {
				clientId: n.clientId,
				month: i
			}),
			/* @__PURE__ */ b(bd, {
				clientId: n.clientId,
				month: i
			}),
			/* @__PURE__ */ x(c.Frame, { children: [/* @__PURE__ */ b(c.Toolbar, { children: /* @__PURE__ */ b(h, {
				variant: "secondary",
				iconStart: "download",
				isPending: u.isPending,
				onPress: () => u.mutate(),
				children: e("list.exportCsv")
			}) }), /* @__PURE__ */ b(c.Table, {
				query: d,
				headerVariant: "plain",
				emptyState: {
					icon: "shapes",
					title: e("rebates.empty.title", { month: rc(i, t) }),
					description: e("rebates.empty.description")
				},
				noResultsState: {
					title: e("rebates.noResults.title"),
					description: e("rebates.noResults.description")
				}
			})] })
		]
	});
}
//#endregion
//#region src/lib/routes/RedirectPreservingSearch.tsx
function Md({ to: e }) {
	let { search: t } = Ze();
	return /* @__PURE__ */ b(qe, {
		to: {
			pathname: Za(Eo(), e, ""),
			search: t
		},
		replace: !0
	});
}
//#endregion
//#region src/lib/routes/ibRoutes.tsx
var Nd = [{
	element: /* @__PURE__ */ b(Mo, {}),
	children: [
		{
			index: !0,
			element: /* @__PURE__ */ b(Md, { to: U.overview })
		},
		{
			path: U.overview,
			element: /* @__PURE__ */ b(iu, {})
		},
		{
			path: U.clients,
			element: /* @__PURE__ */ b(Xu, {})
		},
		{
			path: U.subIbs,
			element: /* @__PURE__ */ b(ad, {})
		},
		{
			path: U.rebates,
			element: /* @__PURE__ */ b(jd, {})
		},
		{
			path: "*",
			element: /* @__PURE__ */ b(Md, { to: U.overview })
		}
	]
}];
//#endregion
//#region src/lib/IbDesk.tsx
function Pd() {
	let e = Qe(), t = tt(Nd);
	return /* @__PURE__ */ b(rt, {
		locale: q(),
		children: /* @__PURE__ */ b(it, {
			navigate: e,
			useHref: Xe,
			children: /* @__PURE__ */ x("div", {
				className: "flex flex-1 flex-col",
				children: [/* @__PURE__ */ b(bo, {}), t]
			})
		})
	});
}
//#endregion
//#region src/lib/IbDeskProvider.tsx
function Fd({ http: e, baseUrl: t, isAvailable: n, isEnabled: r, externalId: i, symbolIconsBaseUrl: a, isMocksEnabled: o = !1, switchBonusTermsUrl: s = "", children: c }) {
	return /* @__PURE__ */ b(Ba, {
		value: {
			http: e,
			baseUrl: t,
			isAvailable: n,
			isEnabled: r,
			isMocksEnabled: o,
			switchBonusTermsUrl: s,
			symbolIconsBaseUrl: a,
			externalId: o ? rr : i
		},
		children: /* @__PURE__ */ b(Ha, { children: /* @__PURE__ */ b(ao, { children: /* @__PURE__ */ b(lo, { children: c }) }) })
	});
}
//#endregion
export { W as FEATURE_IB_NAMESPACE, Pd as IbDesk, Fd as IbDeskProvider, mo as IbProgramSelect, Nd as ibRoutes, ho as useIbMembership, go as useIbNavigation };
